(function () {
  if (window.SnooozeFindMyPillowQuizLoaded) return;
  window.SnooozeFindMyPillowQuizLoaded = true;

  const PRODUCT_RECORDS = [
    {
      id: 'mini_snoooze',
      handle: 'mini-snoooze-travel-pillow',
      sku: 'SNOOZE0003',
      family: 'mini',
      fallbackPrice: 25.9,
      size: 'Mini - 30 x 40 cm',
      weight: 400,
      fill: 'down-alternative fibre',
      shell: 'cotton',
      containsFeatherDown: false,
      containsLatex: false,
      pillowcaseIncluded: true,
      pillowcaseType: 'cotton',
      velcroBagIncluded: false,
      feel: 'soft, snug, compact',
      care: 'machine washable',
      profile: ['value', 'compact', 'soft', 'easy_care', 'hygiene_surface'],
      bestIf: 'you want the easiest compact Snoooze option for short trips, carry-on travel or a clean hotel-pillow surface.',
      notIdealIf: 'you need full home-pillow surface or strong height from the pillow alone.',
      setup: 'Try it alone first for a clean soft layer. If the hotel pillow is too low, use the hotel pillow underneath as a base.'
    },
    {
      id: 'all_silk_mini',
      handle: 'all-silk-travel-mini-pillow',
      sku: 'ALLSILK',
      family: 'mini',
      fallbackPrice: 78.8,
      size: 'Mini - 30 x 40 cm',
      weight: 400,
      fill: 'mulberry silk',
      shell: 'mulberry silk',
      containsFeatherDown: false,
      containsLatex: false,
      pillowcaseIncluded: true,
      pillowcaseType: 'silk',
      velcroBagIncluded: true,
      feel: 'soft-to-medium, smoother, cooler, premium',
      care: 'silk pillowcase washable; inner pillow spot-clean only',
      profile: ['premium', 'compact', 'silk', 'skin_hair', 'hot_sleep', 'gift'],
      bestIf: 'you want a compact premium pillow with a smoother silk surface for skin and hair.',
      notIdealIf: 'you need strong structure, full-size support or the simplest wash-all care.',
      setup: 'Use it as your clean compact pillow for the journey and hotel bed. The silk surface is already included.'
    },
    {
      id: 'goose_down_mini',
      handle: 'ukrainian-goose-mini-pillow',
      sku: 'GMINI',
      family: 'mini',
      fallbackPrice: 49.8,
      size: 'Mini - 30 x 40 cm',
      weight: 350,
      fill: '90% Ukrainian goose down',
      shell: 'cotton',
      containsFeatherDown: true,
      containsLatex: false,
      pillowcaseIncluded: true,
      pillowcaseType: 'cotton',
      velcroBagIncluded: true,
      feel: 'very soft, light, mouldable',
      care: 'machine washable',
      profile: ['compact', 'natural_down', 'very_soft', 'low_soft', 'gift'],
      bestIf: 'you love a very soft natural down feel in the smallest travel size.',
      notIdealIf: 'you avoid feather or down, hate collapse, or need firm structure.',
      setup: 'Use it alone for soft low comfort, or as a clean soft top layer if the hotel pillow is too low.'
    },
    {
      id: 'supreme_3ch_mini',
      handle: 'goose-mini-sandwich-pillow',
      sku: 'MiniSandwichPillow',
      family: 'mini',
      fallbackPrice: 46.8,
      size: 'Mini - 30 x 40 cm',
      weight: 450,
      fill: 'duck down outer chambers and duck feather inner chamber',
      shell: '300TC cotton',
      containsFeatherDown: true,
      containsLatex: false,
      pillowcaseIncluded: true,
      pillowcaseType: 'cotton',
      velcroBagIncluded: true,
      feel: 'soft outside, more structured inside, medium support',
      care: 'machine washable',
      profile: ['compact', 'structured', 'medium', 'supportive', 'side_sleep'],
      bestIf: 'you need the most supportive compact Snoooze option and still have limited luggage space.',
      notIdealIf: 'you avoid feather or down, want very soft collapse, or expect a full home-pillow surface.',
      setup: 'Use it mainly by itself. It is more structured than the softer Mini pillows, so it is usually less useful as a top layer.'
    },
    {
      id: 'full_size_snoooze',
      handle: 'soft-full-size-snoooze-portable-pillow',
      sku: '855',
      family: 'full_portable',
      fallbackPrice: 36.8,
      size: 'Full-size portable - approx 42 x 55 cm',
      weight: 600,
      fill: 'premium down-alternative microfiber',
      shell: '280TC downproof cotton',
      containsFeatherDown: false,
      containsLatex: false,
      pillowcaseIncluded: true,
      pillowcaseType: 'cotton',
      velcroBagIncluded: false,
      feel: 'soft-to-medium, down-like, slightly adjustable',
      care: 'machine washable',
      profile: ['value', 'full_surface', 'soft', 'easy_care', 'no_down'],
      bestIf: 'you want a good-value full-size portable pillow for flights and hotels without feather or down.',
      notIdealIf: 'you travel backpack-only or need strong exact-height structure.',
      setup: 'Try it alone first. If the hotel pillow is too low, use the hotel pillow underneath as a base.'
    },
    {
      id: 'adaptgo',
      handle: 'adaptgo-fullsize-portable-pillow-set-1',
      sku: 'Adaptgo',
      family: 'full_portable',
      fallbackPrice: 45.8,
      size: 'Full-size portable - approx 42 x 55 cm',
      weight: 900,
      fill: 'down-alternative outer shell with removable inserts, including latex insert',
      shell: 'cotton',
      containsFeatherDown: false,
      containsLatex: true,
      pillowcaseIncluded: true,
      pillowcaseType: 'cotton',
      velcroBagIncluded: true,
      feel: 'adjustable from flat to firmer, exact height system',
      care: 'pillowcase and outer shell washable; inserts wipe-clean only',
      profile: ['full_surface', 'adjustable', 'exact_height', 'mixed_sleep', 'no_down'],
      bestIf: 'hotel pillows are different every trip and you want to tune the height instead of guessing.',
      notIdealIf: 'you avoid latex or want the simplest no-adjustment pillow.',
      setup: 'Start flatter, then add inserts only if the hotel pillow setup feels too low.'
    },
    {
      id: 'goose_flat_full',
      handle: 'goose-down-flat-portable-full-size-pillow',
      sku: 'GFLAT',
      family: 'full_portable',
      fallbackPrice: 59.7,
      size: 'Full-size portable - approx 42 x 55 cm',
      weight: 390,
      fill: '90% Ukrainian goose down',
      shell: 'cotton',
      containsFeatherDown: true,
      containsLatex: false,
      pillowcaseIncluded: true,
      pillowcaseType: 'cotton',
      velcroBagIncluded: true,
      feel: 'low, soft, flat, light, natural down',
      care: 'washable cotton shell',
      profile: ['full_surface', 'natural_down', 'low_soft', 'very_soft', 'lightweight'],
      bestIf: 'you want full-size surface but low soft height and lighter packing than a fuller pillow.',
      notIdealIf: 'you avoid feather or down, need height from one pillow, or want medium-firm support.',
      setup: 'Use it alone if the hotel pillow is high. If the hotel pillow is too low, layer this on top for a softer clean surface.'
    },
    {
      id: 'goose_down_full',
      handle: 'ukranian-goose-portable-full-size-pillow',
      sku: 'GFULL',
      family: 'full_portable',
      fallbackPrice: 77.8,
      size: 'Full-size portable - approx 42 x 55 cm',
      weight: 900,
      fill: '90% Ukrainian goose down',
      shell: 'cotton',
      containsFeatherDown: true,
      containsLatex: false,
      pillowcaseIncluded: true,
      pillowcaseType: 'cotton',
      velcroBagIncluded: true,
      feel: 'soft-to-medium, luxury, natural down',
      care: 'machine washable',
      profile: ['full_surface', 'natural_down', 'soft', 'premium', 'window_flight'],
      bestIf: 'you want a fuller natural down travel pillow and have enough room to pack it.',
      notIdealIf: 'you avoid feather or down, travel backpack-only, or need firm structure.',
      setup: 'Try it alone first. If the hotel pillow is too low, use the hotel pillow underneath as a base.'
    },
    {
      id: 'supreme_3ch_full',
      handle: 'full-size-portable-duck-sandwich-pillow',
      sku: 'AdultSandwichPillow',
      family: 'full_portable',
      fallbackPrice: 65.5,
      size: 'Full-size portable - approx 42 x 55 cm',
      weight: 900,
      fill: 'duck down outer chambers and duck feather inner chamber',
      shell: '300TC cotton',
      containsFeatherDown: true,
      containsLatex: false,
      pillowcaseIncluded: true,
      pillowcaseType: 'cotton',
      velcroBagIncluded: true,
      feel: 'soft outside, structured inside, firmest full-size portable',
      care: 'machine washable',
      profile: ['full_surface', 'structured', 'medium_firm', 'side_sleep', 'supportive'],
      bestIf: 'you want proper medium support from a travel pillow and dislike collapse.',
      notIdealIf: 'you avoid feather or down, travel backpack-only, or prefer very soft collapse.',
      setup: 'Use it mainly by itself for a more supportive hotel-pillow replacement.'
    },
    {
      id: 'large_goose_down',
      handle: 'home-size-pillow-with-velcro-travel-bag',
      sku: 'GRANDV',
      family: 'large',
      fallbackPrice: 108.8,
      size: 'Large - standard UK pillow approx 50 x 75 cm',
      weight: 1000,
      fill: '90% Ukrainian goose down',
      shell: 'cotton',
      containsFeatherDown: true,
      containsLatex: false,
      pillowcaseIncluded: false,
      pillowcaseType: 'none',
      velcroBagIncluded: true,
      feel: 'soft-to-medium, luxury, closest soft home comfort',
      care: 'machine washable',
      profile: ['large_surface', 'natural_down', 'premium', 'soft', 'comfort_first'],
      bestIf: 'you travel comfort-first with checked luggage, car, camper or an extra bag.',
      notIdealIf: 'you avoid feather or down, travel compact, or forget to pack a standard UK pillowcase.',
      setup: 'This is comfort-first travel. It is bulky, has a Velcro travel bag, and needs a standard UK pillowcase.'
    },
    {
      id: 'supreme_3ch_large',
      handle: 'supreme-3-chamber-large-pillow',
      sku: '28072025',
      family: 'large',
      fallbackPrice: 77.5,
      size: 'Large - standard UK pillow approx 50 x 75 cm',
      weight: 1000,
      fill: 'duck down outer chambers and duck feather inner chamber',
      shell: 'cotton',
      containsFeatherDown: true,
      containsLatex: false,
      pillowcaseIncluded: false,
      pillowcaseType: 'none',
      velcroBagIncluded: true,
      feel: 'medium luxury, more supportive, structured core',
      care: 'check live product care',
      profile: ['large_surface', 'structured', 'medium_firm', 'side_sleep', 'comfort_first'],
      bestIf: 'you want a home-size travel pillow with more structure for longer stays.',
      notIdealIf: 'you avoid feather or down, need compact packing, or do not have a standard UK pillowcase.',
      setup: 'This is comfort-first travel. It is bulky, has a Velcro travel bag, and needs a standard UK pillowcase.'
    }
  ];

  const ACCESSORY_RECORDS = [
    {
      id: 'mini_cotton_case',
      handles: ['mini-peach-coral-cotton-pillowcase', 'mini-aqua-mist-pillowcase', 'mini-snoooze-pillowcase', 'mini-cotton-pillowcase'],
      families: ['mini'],
      type: 'spare_case',
      label: 'Spare mini cotton pillowcase',
      reason: 'Use one pillowcase for the journey and one clean case for bed. A brighter colour is easier to spot in hotel bedding.'
    },
    {
      id: 'full_cotton_case',
      handles: ['snoooze-pillowcase', 'full-size-aqua-mist-pillowcase', 'full-size-duck-egg-blue-pillowcase', 'full-size-cotton-pillowcase'],
      families: ['full_portable'],
      type: 'spare_case',
      label: 'Spare full-size cotton pillowcase',
      reason: 'Use one pillowcase for the journey and one clean case for bed. A visible colour is easier to spot in hotel bedding.'
    },
    {
      id: 'mini_silk_case',
      handles: ['mini-silk-pillowcase-black', 'mini-champagne-glow-silk-pillowcase', 'mini-silk-pillowcase'],
      families: ['mini'],
      type: 'silk_case',
      label: 'Mini silk pillowcase',
      reason: 'Choose silk if you want a smoother surface for skin and hair, or a cooler premium feel.'
    },
    {
      id: 'full_silk_case',
      handles: ['snoooze-silk-pillowcase-1', 'full-size-silk-pillowcase', 'full-size-champagne-glow-silk-pillowcase', 'full-size-sky-silk-pillowcase', 'full-size-blush-pink-silk-pillowcase'],
      families: ['full_portable'],
      type: 'silk_case',
      label: 'Full-size silk pillowcase',
      reason: 'Choose silk if you want a smoother surface for skin and hair, or a cooler premium feel.'
    },
    {
      id: 'large_standard_case',
      handles: ['standard-uk-pillowcase', 'large-silk-pillowcase', 'snoooze-pillowcase'],
      families: ['large'],
      type: 'large_case',
      label: 'Standard UK pillowcase',
      reason: 'Large Snoooze pillows do not include a pillowcase, so pack a standard UK pillowcase.'
    },
    {
      id: 'easypack',
      handles: ['easypack-dualfit-pillow-bag', 'easypack-dualfit-pillow-bag-navy', 'easy-pack-pillow-bag', 'easypack-pillow-bag'],
      families: ['mini', 'full_portable'],
      type: 'easypack',
      label: 'EasyPack Velcro bag',
      reason: 'Worth adding if you want lower-effort packing: easier to roll and secure, with less fighting with the bag.'
    },
    {
      id: 'gift_box',
      handles: ['gift-box', 'snoooze-gift-box'],
      families: ['mini', 'full_portable', 'large'],
      type: 'gift',
      label: 'Gift box',
      reason: 'Useful when the pillow is a present and a gift-ready setup matters.'
    }
  ];

  const QUESTIONS = [
    {
      id: 'first_intent',
      title: 'Who are you choosing for?',
      why: "Choose a path and we'll guide you to one clear recommendation.",
      type: 'single',
      options: [
        {
          value: 'self',
          label: 'Choose for myself',
          hint: 'Tell us about your trips, packing space, and what usually goes wrong with pillows away from home.'
        },
        {
          value: 'gift',
          label: 'Help me choose a gift',
          hint: "We'll suggest a safe, useful match without asking you to know every sleep detail."
        }
      ]
    },
    {
      id: 'personal_travel_style',
      title: 'Is it more for flights, hotels, or both?',
      why: 'This keeps the chooser simple and points us toward the right size, feel, and packing style.',
      type: 'single',
      options: [
        {
          value: 'flights_sitting',
          label: 'Flights, airports, or long sitting',
          hint: 'For naps, long-haul flights, waiting, car, train, or coach.'
        },
        {
          value: 'hotels_work',
          label: 'Hotels, Airbnb, or work trips',
          hint: 'For bad hotel pillows, Airbnb beds, guest rooms, and work trips.'
        },
        {
          value: 'travel_and_hotel',
          label: 'Both travel days and hotel beds',
          hint: 'One pillow to use during the journey and then in bed.'
        },
        {
          value: 'car_camper_long',
          label: 'Car, camper, boat, or long stays',
          hint: 'When space matters less and comfort matters more.'
        },
        {
          value: 'safe_travel_choice',
          label: "I'm not sure - I want the safest travel choice",
          hint: "We'll choose the most useful, easy-to-pack option."
        }
      ]
    },
    {
      id: 'personal_luggage',
      title: 'Last detail: what packing style feels right?',
      why: 'Choose the option that feels natural for your trip. Mini is easiest to pack; Full Size gives more surface; Large only makes sense when compact packing is not the priority.',
      type: 'single',
      options: [
        {
          value: 'backpack',
          label: 'Small bag or under-seat space',
          hint: 'Mini pillows or very light low-profile options fit best here.'
        },
        {
          value: 'hand_luggage',
          label: 'Hand luggage or a small weekender',
          hint: 'Mini or Full Size portable pillows can both work.'
        },
        {
          value: 'checked_luggage',
          label: 'Checked bag or a little more room',
          hint: 'Full Size portable pillows become easy to bring.'
        },
        {
          value: 'extra_bag_ok',
          label: 'Car, camper, boat, or extra pillow bag',
          hint: 'Comfort-first options can be considered when space is less tight.'
        }
      ]
    },
    {
      id: 'personal_sleep_away_problem',
      title: 'What usually goes wrong when you sleep away from home?',
      why: 'This helps us fix the real problem: clean surface, wrong height, too much bulk, too little support, or unpredictable pillows.',
      type: 'multi',
      options: [
        {
          value: 'clean_surface',
          label: 'I want my own clean pillow surface',
          hint: 'Good if you want your own clean surface.'
        },
        {
          value: 'too_high_bulky_hard',
          label: 'Pillows are too high, bulky, or hard',
          hint: 'Good if you prefer something lower, softer, and less bulky.'
        },
        {
          value: 'too_low_flat_collapse',
          label: 'Pillows are too low, flat, or collapse',
          hint: 'Good if soft pillows feel too flat or disappear under you.'
        },
        {
          value: 'flight_sitting_sleep',
          label: 'I struggle to sleep on flights or while sitting',
          hint: 'Useful when you want comfort during sitting, not only sleeping.'
        },
        {
          value: 'different_every_trip',
          label: 'Hotel pillows are different every trip',
          hint: 'Good if every trip feels like a different pillow problem.'
        },
        {
          value: 'closer_to_home',
          label: 'I just want something closer to my pillow at home',
          hint: 'Good if you are willing to carry more for a familiar pillow feel.'
        }
      ]
    },
    {
      id: 'personal_pillow_feel',
      title: 'What pillow feel usually works best for you?',
      why: 'This is the fastest way to avoid the wrong pillow. We do not need perfect measurements - just the feel you normally like.',
      type: 'single',
      options: [
        {
          value: 'low_soft',
          label: 'Low and soft - I hate high pillows',
          hint: 'Best for people who dislike height.'
        },
        {
          value: 'soft_sink',
          label: 'Very soft and sink-in - like classic down',
          hint: 'Best if you like soft, mouldable pillows.'
        },
        {
          value: 'balanced_medium',
          label: 'Balanced medium - soft but not flat',
          hint: 'Best everyday travel feel.'
        },
        {
          value: 'more_supportive',
          label: 'More supportive - I hate pillows that collapse',
          hint: 'Best if you need more hold or are often disappointed by flat pillows.'
        },
        {
          value: 'adjustable',
          label: 'Adjustable - I want to change the height if needed',
          hint: 'Best if hotel pillows are unpredictable.'
        },
        {
          value: 'not_sure',
          label: "I'm not sure - choose the safest feel",
          hint: "We'll choose a safe all-round option."
        }
      ]
    },
    {
      id: 'personal_material_practical_needs',
      title: 'Anything important before we choose?',
      why: 'These answers protect you from the wrong material, care level, or packing experience.',
      type: 'multi',
      options: [
        {
          value: 'avoid_down',
          label: 'Avoid feather or down',
          hint: "We'll remove goose/down and 3-chamber feather products."
        },
        {
          value: 'avoid_latex',
          label: 'Avoid latex',
          hint: "We'll remove AdaptGo because one insert contains latex."
        },
        {
          value: 'easy_care',
          label: 'Easy washable care matters',
          hint: "We'll favour simpler washable options."
        },
        {
          value: 'natural_down',
          label: 'I love natural down softness',
          hint: "We'll favour goose down where suitable."
        },
        {
          value: 'skin_hair_hot',
          label: 'I care about skin, hair, or sleeping hot',
          hint: "We'll show silk pillow or silk pillowcase where it makes sense."
        },
        {
          value: 'low_effort_packing',
          label: 'I want low-effort packing',
          hint: "We'll favour Velcro bags or offer EasyPack only when compatible."
        },
        {
          value: 'no_preference',
          label: 'No strong preference',
          hint: "We'll keep the recommendation simple."
        }
      ]
    },
    {
      id: 'personal_result_preference',
      title: 'How should we show your result?',
      why: 'We can keep it simple, or show a lower-price option if the best match is more expensive.',
      type: 'single',
      options: [
        {
          value: 'best_match_only',
          label: 'Best match only',
          hint: 'One clear recommendation.'
        },
        {
          value: 'best_value_first',
          label: 'Best value first',
          hint: 'Prioritise good fit at a lower price.'
        },
        {
          value: 'best_plus_lower',
          label: 'Show the best match and a lower-price option',
          hint: 'Useful if you want to compare without getting overwhelmed.'
        },
        {
          value: 'premium_upgrade',
          label: 'Show a premium upgrade if it is worth it',
          hint: 'Only shown if the upgrade changes comfort or surface feel.'
        }
      ]
    }
  ];

  const GIFT_QUESTIONS = [
    {
      id: 'user_for_whom',
      title: 'Who are you buying for?',
      why: 'This keeps the gift route safe without asking for exact pillow height or technical sleep details.',
      type: 'single',
      options: [
        ['gift_young', 'Younger traveller / child / teen'],
        ['gift_adult', 'Adult traveller'],
        ['gift_parent', 'Parent or older adult'],
        ['gift_couple', 'Couple or shared gift'],
        ['gift_unsure', "I'm not sure"]
      ]
    },
    {
      id: 'gift_travel_type',
      title: 'What kind of travel will this gift help with most?',
      why: 'A flight gift, hotel gift, and long-stay gift are not the same. We will choose something they are likely to bring and use.',
      type: 'single',
      options: [
        ['flights_sitting', 'Flights, airports, and long sitting'],
        ['hotels_work', 'Hotels, Airbnb, or work trips'],
        ['travel_and_hotel', 'Both travel days and hotel beds'],
        ['car_camper_long', 'Car, camper, boat, or long stays'],
        ['safe_travel_gift', "I'm not sure - I want a safe travel gift"]
      ]
    },
    {
      id: 'gift_feeling',
      title: 'What kind of gift do you want it to feel like?',
      why: 'Some gifts should feel practical. Some should feel soft and cosy. Some should feel premium. This helps us choose the right version.',
      type: 'single',
      options: [
        ['practical', 'Useful and practical'],
        ['soft_cosy', 'Soft and cosy'],
        ['premium_special', 'Premium and special'],
        ['skin_hair_hot', 'Good for skin, hair, or sleeping hot'],
        ['supportive_substantial', 'More supportive and substantial']
      ]
    },
    {
      id: 'gift_material_avoidance',
      title: 'Anything we should avoid?',
      why: 'This helps us avoid a gift that may not suit them. If you are not sure, we will choose the safer material route.',
      type: 'multi',
      options: [
        ['avoid_down', 'Avoid feather or down'],
        ['avoid_latex', 'Avoid latex'],
        ['easy_washable', 'Easy washable care matters'],
        ['natural_down', 'They love natural down softness'],
        ['safe_unknown', "I don't know - choose safely"]
      ]
    },
    {
      id: 'gift_packing_style',
      title: 'Last detail: what packing style feels safest for this gift?',
      why: 'If you are not sure, keep it easy to pack. Mini is safest for unknown trips; Full Size or comfort-first pillows only make sense when you know they have room.',
      type: 'single',
      options: [
        ['small_bag', 'Small bag or under-seat space'],
        ['cabin_weekender', 'Cabin suitcase or weekender'],
        ['checked_extra', 'Checked luggage, car, camper, or extra bag'],
        ['unknown_easy', "I am not sure - keep it easy to pack"]
      ]
    },
    {
      id: 'gift_price_preference',
      title: 'What price level should we show?',
      why: 'We can show one safest match, or a better gift option if the upgrade is worth it.',
      type: 'single',
      options: [
        ['value_gift', 'Best value gift'],
        ['balanced_gift', 'Balanced gift - useful but still special'],
        ['premium_gift', 'Premium gift'],
        ['best_plus_lower', 'Show the best match and a lower-price option']
      ]
    }
  ];

  const FLIGHT_QUESTIONS = [
    {
      id: 'flight_use_scope',
      title: 'Is this mainly for the flight, or for the hotel too?',
      why: 'This changes the best setup. A flight-only pillow should be easy to keep with you on board. If you also want it for the hotel bed, we may suggest a spare pillowcase.',
      type: 'single',
      options: [
        {
          value: 'flight_only',
          label: 'Flight only',
          hint: "We'll focus on comfort you can use in your seat."
        },
        {
          value: 'flight_plus_hotel',
          label: 'Flight plus hotel bed',
          hint: "We'll also think about clean pillowcase use after the journey."
        },
        {
          value: 'mostly_flight_hotel_bonus',
          label: 'Mostly flight, but nice to have in the hotel too',
          hint: "We'll keep it flight-friendly, with hotel use as a bonus."
        },
        {
          value: 'long_sitting',
          label: 'Airport, car, train, coach, and long sitting',
          hint: 'Good when you want comfort during sitting, not only sleeping.'
        }
      ]
    },
    {
      id: 'flight_length',
      title: 'How long is the flight you usually want help with?',
      why: 'A short flight may need a small comfort upgrade. Long-haul or overnight trips can be nicer with more pillow surface.',
      type: 'single',
      options: [
        {
          value: 'under_3',
          label: 'Under 3 hours',
          hint: 'Small and easy to pack usually wins.'
        },
        {
          value: 'three_to_six',
          label: '3-6 hours',
          hint: 'Compact comfort or soft support can be enough.'
        },
        {
          value: 'six_plus',
          label: '6+ hours / long-haul',
          hint: 'More surface can feel worth it on longer journeys.'
        },
        {
          value: 'overnight',
          label: 'Overnight flight',
          hint: 'A real pillow setup becomes more valuable when you need proper rest.'
        },
        {
          value: 'frequent',
          label: 'I travel often, so I want something reliable',
          hint: 'Durability, hygiene, and packing ease matter more.'
        }
      ]
    },
    {
      id: 'flight_onboard_carry',
      title: 'Last detail: what packing style feels easiest?',
      why: 'No need to overthink it. Mini is easiest to keep with you; Full Size portable gives more pillow surface if you can keep it easy to reach.',
      type: 'single',
      options: [
        {
          value: 'personal_bag',
          label: 'Small bag or under-seat space',
          hint: 'Mini pillows are the easiest fit.'
        },
        {
          value: 'rolled_clipped',
          label: 'Clipped, rolled, or easy to reach with my carry-on',
          hint: 'Mini or compact Full Size portable pillows can work.'
        },
        {
          value: 'cabin_take_out',
          label: 'I can make room for a Full Size portable pillow',
          hint: 'Good for longer flights when you want more surface than Mini.'
        }
      ]
    },
    {
      id: 'flight_seat_reality',
      title: 'How do you want to use it on the plane?',
      why: 'Best setup: choose a window or lie-flat seat when you can. If you are in an aisle or middle seat, we will keep the recommendation useful for hugging, lap comfort, cheek support or lower-back support.',
      type: 'single',
      options: [
        {
          value: 'window',
          label: 'I can choose a window or lie-flat setup when I can',
          hint: 'Best for resting your head against a stable side surface.'
        },
        {
          value: 'aisle_middle',
          label: 'My seat changes, so I need a flexible pillow',
          hint: 'Useful for window, aisle, middle, car, train, coach or airport waits.'
        },
        {
          value: 'changes_unknown',
          label: 'I mostly want comfort while sitting',
          hint: 'Good for hug, lap, cheek or lower-back comfort when head support is not realistic.'
        }
      ]
    },
    {
      id: 'flight_main_needs',
      title: 'What matters most for this flight pillow?',
      why: "Choose what would make the biggest difference on the journey. We'll use this to avoid the wrong feel or material.",
      type: 'multi',
      options: [
        {
          value: 'clean_surface',
          label: 'I want my own clean pillow surface',
          hint: 'Good for flights and hotel beds.'
        },
        {
          value: 'soft_comfort',
          label: 'I want soft comfort to lean on',
          hint: 'Soft, cosy, and easy to rest against.'
        },
        {
          value: 'more_support',
          label: 'I need more support - soft pillows collapse on me',
          hint: 'Choose this if soft pillows collapse on you.'
        },
        {
          value: 'low_not_bulky',
          label: 'I want something low and not bulky',
          hint: 'Best when you dislike high or bulky pillows.'
        },
        {
          value: 'skin_hair_hot',
          label: 'I care about skin, hair, or sleeping hot',
          hint: "We'll show silk where it makes sense."
        },
        {
          value: 'avoid_down',
          label: 'Avoid feather or down',
          hint: "We'll remove goose/down and feather products."
        },
        {
          value: 'avoid_latex',
          label: 'Avoid latex',
          hint: "We'll remove AdaptGo."
        },
        {
          value: 'easy_care',
          label: 'Easy washable care matters',
          hint: "We'll favour simpler care."
        },
        {
          value: 'low_effort_packing',
          label: 'Low-effort packing matters',
          hint: "We'll favour Velcro bags or compatible EasyPack."
        },
        {
          value: 'best_value',
          label: 'Best value matters',
          hint: "We'll show a lower-price option if it still fits."
        }
      ]
    }
  ];

  const HOTEL_TRIP_LENGTH_QUESTION = {
    id: 'hotel_trip_length',
    title: 'How long is the trip or stay?',
    why: 'Longer stays can justify more pillow surface. Shorter trips often need something easier to pack.',
    type: 'single',
    options: [
      {
        value: 'one_two_nights',
        label: '1-2 nights',
        hint: 'Keep it compact and easy.'
      },
      {
        value: 'weekend_short',
        label: 'Weekend or short break',
        hint: 'A Mini or Full-size portable pillow can both make sense.'
      },
      {
        value: 'week_or_more',
        label: 'A week or more',
        hint: 'More surface can be worth the extra packing space.'
      },
      {
        value: 'frequent_hotels',
        label: 'Frequent hotels or regular work trips',
        hint: 'A reliable hotel-pillow setup matters more.'
      },
      {
        value: 'comfort_first',
        label: 'Long stay, car, camper, boat, or extra bag',
        hint: 'Comfort-first pillows can be considered when space is less tight.'
      }
    ]
  };

  const HOTEL_QUESTIONS = [
    QUESTIONS.find((question) => question.id === 'personal_sleep_away_problem'),
    HOTEL_TRIP_LENGTH_QUESTION,
    QUESTIONS.find((question) => question.id === 'personal_pillow_feel'),
    QUESTIONS.find((question) => question.id === 'personal_material_practical_needs'),
    QUESTIONS.find((question) => question.id === 'personal_luggage')
  ].filter(Boolean);

  const UNSURE_QUESTIONS = [
    QUESTIONS.find((question) => question.id === 'personal_travel_style'),
    QUESTIONS.find((question) => question.id === 'personal_pillow_feel'),
    QUESTIONS.find((question) => question.id === 'personal_material_practical_needs'),
    QUESTIONS.find((question) => question.id === 'personal_luggage')
  ].filter(Boolean);

  const ALL_QUESTIONS = QUESTIONS.concat(GIFT_QUESTIONS, FLIGHT_QUESTIONS, HOTEL_QUESTIONS, UNSURE_QUESTIONS);
  const GIFT_USER_VALUES = new Set(['gift_young', 'gift_adult', 'gift_parent', 'gift_couple', 'gift_unsure']);
  const EXCLUDED_PRODUCT_IDS = new Set(['cottonlux_bounce', 'cottonlux_silk_bundle', 'cottonlux_silk_mask_bundle', 'pillow_power_pack', 'goose_flat_full']);

  const ANSWER_LABELS = ALL_QUESTIONS.reduce((labels, question) => {
    question.options.forEach((option) => {
      labels[`${question.id}:${getOptionValue(option)}`] = getOptionLabel(option);
    });
    return labels;
  }, {});

  function getOptionValue(option) {
    return Array.isArray(option) ? option[0] : option.value;
  }

  function getOptionLabel(option) {
    return Array.isArray(option) ? option[1] : option.label;
  }

  function getOptionHint(option) {
    return Array.isArray(option) ? '' : (option.hint || '');
  }

  function initAll(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-pillow-quiz]:not([data-quiz-ready])').forEach(initQuiz);
  }

  function initQuiz(quiz) {
    quiz.dataset.quizReady = 'true';

    const section = quiz.closest('.pillow-advisor');
    const configNode = section ? section.querySelector('[data-pillow-quiz-config]') : null;
    const config = parseConfig(configNode);
    const state = {
      quiz,
      config,
      answers: {},
      currentStep: 0,
      liveProducts: new Map(),
      liveAccessories: new Map(),
      started: false,
      giftPathStarted: false,
      flightPathStarted: false,
      pathStarted: '',
      firstScreenViewedTracked: false,
      firstIntentAdvanceTimer: null,
      result: null
    };

    state.loading = quiz.querySelector('[data-quiz-loading]');
    state.form = quiz.querySelector('[data-quiz-form]');
    state.error = quiz.querySelector('[data-quiz-error]');
    state.panel = quiz.querySelector('.pillow-quiz__panel');
    state.host = quiz.querySelector('[data-quiz-step-host]');
    state.back = quiz.querySelector('[data-quiz-back]');
    state.next = quiz.querySelector('[data-quiz-next]');
    state.progressLabel = quiz.querySelector('[data-quiz-progress-label]');
    state.progressFill = quiz.querySelector('[data-quiz-progress-fill]');
    state.resultPanel = quiz.querySelector('[data-quiz-result]');
    state.resultContent = quiz.querySelector('[data-quiz-result-content]');

    state.back.addEventListener('click', () => goBack(state));
    state.next.addEventListener('click', () => goNext(state));
    state.form.addEventListener('change', (event) => onAnswerChange(state, event));
    state.resultPanel.addEventListener('click', (event) => onResultClick(state, event));
    state.resultPanel.addEventListener('submit', (event) => onEmailSubmit(state, event));
    window.addEventListener('pagehide', () => trackAbandonment(state));

    loadLiveData(state)
      .then(() => {
        state.loading.hidden = true;
        state.form.hidden = false;
        renderStep(state);
      })
      .catch(() => {
        state.loading.hidden = true;
        showError(state, 'We could not load live product availability. Please refresh the page before using the quiz.');
      });
  }

  function parseConfig(node) {
    if (!node) return {};
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      return {};
    }
  }

  async function loadLiveData(state) {
    const productHandles = getAllProductHandles();
    const accessoryHandles = getAllAccessoryHandles();
    const productResults = await Promise.all(productHandles.map((handle) => fetchProduct(handle)));
    const accessoryResults = await Promise.all(accessoryHandles.map((handle) => fetchProduct(handle)));

    productResults.forEach((product) => {
      if (product) state.liveProducts.set(product.handle, product);
    });
    accessoryResults.forEach((product) => {
      if (product) state.liveAccessories.set(product.handle, product);
    });

    PRODUCT_RECORDS.forEach((record) => attachLiveProduct(record, state.liveProducts));
    ACCESSORY_RECORDS.forEach((record) => attachLiveProduct(record, state.liveAccessories));

    const availablePillows = PRODUCT_RECORDS.filter((record) => record.family !== 'bundle_offer' && !EXCLUDED_PRODUCT_IDS.has(record.id) && record.available);
    if (!availablePillows.length) {
      throw new Error('No live pillows available');
    }
  }

  function getAllProductHandles() {
    return unique(PRODUCT_RECORDS
      .filter((record) => !EXCLUDED_PRODUCT_IDS.has(record.id))
      .flatMap((record) => record.handles || [record.handle])
      .filter(Boolean));
  }

  function getAllAccessoryHandles() {
    return unique(ACCESSORY_RECORDS.flatMap((record) => record.handles || [record.handle]).filter(Boolean));
  }

  async function fetchProduct(handle) {
    try {
      const response = await fetch(`/products/${handle}.js`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });
      if (!response.ok) return null;
      const product = await response.json();
      const availableVariant = (product.variants || []).find((variant) => variant.available) || null;
      const available = Boolean(product.available || availableVariant);
      return {
        raw: product,
        handle: product.handle || handle,
        title: product.title || handleToTitle(handle),
        price: typeof product.price === 'number' ? product.price : null,
        url: product.url || `/products/${product.handle || handle}`,
        image: product.featured_image || (product.images && product.images[0]) || null,
        variants: product.variants || [],
        availableVariant,
        available
      };
    } catch (error) {
      return null;
    }
  }

  function attachLiveProduct(record, liveMap) {
    const handles = record.handles || [record.handle];
    const live = handles.map((handle) => liveMap.get(handle)).find((product) => product && product.available) || null;
    record.live = live;
    record.available = Boolean(live);
    if (live) {
      record.handle = live.handle;
      record.title = live.title;
      record.price = live.price;
      record.url = live.url;
      record.image = live.image;
      record.availableVariant = live.availableVariant;
    }
  }

  function renderStep(state) {
    const steps = getActiveQuestions(state.answers);
    if (state.currentStep >= steps.length) state.currentStep = steps.length - 1;
    if (state.currentStep < 0) state.currentStep = 0;

    const question = steps[state.currentStep];
    const currentValue = state.answers[question.id] || (question.type === 'multi' ? [] : '');
    const isMulti = question.type === 'multi';

    state.host.innerHTML = `
      <fieldset class="pillow-quiz__fieldset" data-question-id="${escapeHTML(question.id)}">
        <legend class="pillow-quiz__legend">${escapeHTML(question.title)}</legend>
        <p class="pillow-quiz__why">${escapeHTML(question.why)}</p>
        <div class="pillow-quiz__choices pillow-quiz__choices--${isMulti ? 'multi' : 'single'}">
          ${question.options.map((option) => renderOption(question, option, currentValue)).join('')}
        </div>
        <p class="pillow-quiz__validation" data-quiz-validation hidden>Please choose an answer to continue.</p>
      </fieldset>
    `;

    updateProgress(state);
    state.back.hidden = state.currentStep === 0 || question.id === 'first_intent';
    trackFirstScreenViewed(state, question);
    state.resultPanel.hidden = true;
  }

  function updateProgress(state) {
    const steps = getActiveQuestions(state.answers);
    const question = steps[state.currentStep];
    if (question && question.id === 'first_intent') {
      state.progressLabel.textContent = 'Start here';
      state.progressFill.style.width = '0%';
      state.next.textContent = 'Start';
      return;
    }

    state.progressLabel.textContent = `Step ${state.currentStep + 1} of ${steps.length}`;
    state.progressFill.style.width = `${((state.currentStep + 1) / steps.length) * 100}%`;
    state.next.textContent = state.currentStep === steps.length - 1 ? getResultButtonText(state.answers) : 'Next';
  }

  function getResultButtonText(answers) {
    const path = getPathProperties(answers).path;
    if (path === 'gift') return 'See gift result';
    if (path === 'flight') return 'See flight result';
    if (path === 'flight_hotel') return 'See flight + hotel result';
    if (path === 'hotel') return 'See hotel result';
    return 'See my result';
  }

  function trackFirstScreenViewed(state, question) {
    if (!question || question.id !== 'first_intent' || state.firstScreenViewedTracked) return;
    state.firstScreenViewedTracked = true;
    track(state, 'Snoooze Quiz First Screen Viewed', getTrafficProperties(state));
  }

  function renderOption(question, option, currentValue) {
    const value = getOptionValue(option);
    const label = getOptionLabel(option);
    const hint = getOptionHint(option);
    const isMulti = question.type === 'multi';
    const inputType = isMulti ? 'checkbox' : 'radio';
    const checked = isMulti ? currentValue.includes(value) : currentValue === value;
    return `
      <label class="pillow-quiz__choice">
        <input
          class="pillow-quiz__input"
          type="${inputType}"
          name="${escapeHTML(question.id)}"
          value="${escapeHTML(value)}"
          ${checked ? 'checked' : ''}
        >
        <span class="pillow-quiz__choice-card">
          <span class="pillow-quiz__choice-text">
            <span class="pillow-quiz__choice-label">${escapeHTML(label)}</span>
            ${hint ? `<span class="pillow-quiz__choice-hint">${escapeHTML(hint)}</span>` : ''}
          </span>
        </span>
      </label>
    `;
  }

  function onAnswerChange(state, event) {
    const input = event.target.closest('.pillow-quiz__input');
    if (!input) return;
    const question = ALL_QUESTIONS.find((item) => item.id === input.name);
    if (!question) return;

    if (!state.started) {
      state.started = true;
      track(state, 'Snoooze Quiz Started', getTrafficProperties(state));
      window.dispatchEvent(new CustomEvent('snoooze:pillow_quiz_started', { detail: { quiz_version: state.config.quizVersion } }));
    }

    if (question.id === 'first_intent') {
      handleFirstIntentChange(state, question, input.value);
    } else if (question.id === 'user_for_whom') {
      state.answers.user_for_whom = input.value;
      if (isGiftPath(state.answers) && !state.giftPathStarted) {
        state.giftPathStarted = true;
        track(state, 'Snoooze Quiz Gift Path Started', Object.assign(getTrafficProperties(state), getPathProperties(state.answers), {
          first_answer: input.value,
          first_answer_label: answerLabel(question.id, input.value)
        }));
      }
    } else if (question.id === 'personal_travel_style') {
      state.answers.personal_travel_style = input.value;
      if (!state.answers.first_intent && input.value === 'flights_sitting') {
        if (!state.flightPathStarted) {
          state.flightPathStarted = true;
          track(state, 'Snoooze Quiz Flight Path Started', Object.assign(getTrafficProperties(state), {
            path: 'flight',
            first_answer: input.value,
            first_answer_label: answerLabel(question.id, input.value)
          }));
        }
      } else if (!state.answers.first_intent) {
        state.flightPathStarted = false;
      }
    } else if (question.type === 'multi') {
      const checked = Array.from(queryInputsByName(state.form, input.name, ':checked')).map((item) => item.value);
      const normalized = normalizeMultiAnswer(input.value, checked);
      state.answers[input.name] = normalized;
      Array.from(queryInputsByName(state.form, input.name)).forEach((item) => {
        item.checked = normalized.includes(item.value);
      });
    } else {
      state.answers[input.name] = input.value;
    }

    const validation = state.form.querySelector('[data-quiz-validation]');
    if (validation) validation.hidden = true;
    trackAnswerSelected(state, question, input.value);
    updateProgress(state);
    scheduleFirstIntentAdvance(state, question, input.value);
  }

  function handleFirstIntentChange(state, question, value) {
    const baseAnswers = getInitialAnswersForFirstIntent(value);
    state.answers = baseAnswers;
    state.giftPathStarted = false;
    state.flightPathStarted = false;

    const path = getPathProperties(state.answers).path;
    track(state, 'Snoooze Quiz First Intent Selected', Object.assign(getTrafficProperties(state), {
      first_intent: value,
      selected_label: answerLabel(question.id, value),
      path_started: path,
      page_url: window.location.href
    }));

    if (state.pathStarted !== path) {
      state.pathStarted = path;
      track(state, 'Snoooze Quiz Path Started', Object.assign(getTrafficProperties(state), {
        path,
        first_intent: value
      }));
    }

    if (path === 'gift') state.giftPathStarted = true;
    if (path === 'flight' || path === 'flight_hotel') state.flightPathStarted = true;
  }

  function getInitialAnswersForFirstIntent(value) {
    const answers = { first_intent: value };
    if (value === 'flight') {
      answers.personal_travel_style = 'flights_sitting';
      answers.flight_use_scope = 'flight_only';
    } else if (value === 'flight_hotel') {
      answers.personal_travel_style = 'travel_and_hotel';
      answers.flight_use_scope = 'flight_plus_hotel';
    } else if (value === 'hotel') {
      answers.personal_travel_style = 'hotels_work';
    } else if (value === 'unsure') {
      answers.personal_travel_style = '';
    }
    return answers;
  }

  function scheduleFirstIntentAdvance(state, question, value) {
    if (question.id !== 'first_intent') return;
    clearTimeout(state.firstIntentAdvanceTimer);
    state.firstIntentAdvanceTimer = window.setTimeout(() => {
      if (state.currentStep === 0 && state.answers.first_intent === value) {
        goNext(state);
      }
    }, 320);
  }

  function normalizeMultiAnswer(changedValue, checked) {
    if (changedValue === 'no_preference' && checked.includes('no_preference')) {
      return ['no_preference'];
    }
    if (changedValue === 'safe_unknown' && checked.includes('safe_unknown')) {
      return ['safe_unknown'];
    }
    return checked.filter((value) => !['no_preference', 'safe_unknown'].includes(value));
  }

  function goBack(state) {
    clearTimeout(state.firstIntentAdvanceTimer);
    state.currentStep -= 1;
    renderStep(state);
  }

  function goNext(state) {
    clearTimeout(state.firstIntentAdvanceTimer);
    const steps = getActiveQuestions(state.answers);
    const question = steps[state.currentStep];
    if (!hasAnswer(state.answers, question)) {
      const validation = state.form.querySelector('[data-quiz-validation]');
      if (validation) validation.hidden = false;
      return;
    }

    trackStepCompleted(state, question);

    if (state.currentStep >= steps.length - 1) {
      const result = buildResult(state);
      state.result = result;
      renderResult(state, result);
      return;
    }

    state.currentStep += 1;
    renderStep(state);
  }

  function hasAnswer(answers, question) {
    const value = answers[question.id];
    return Array.isArray(value) ? value.length > 0 : Boolean(value);
  }

  function getActiveQuestions(answers) {
    if (!answers.first_intent) return [QUESTIONS[0]];

    const path = getPathProperties(answers).path;
    if (path === 'gift') return [QUESTIONS[0]].concat(GIFT_QUESTIONS.filter((question) => question.id !== 'gift_price_preference'));
    if (path === 'flight') return [QUESTIONS[0]].concat(getFlightRouteQuestions());
    if (path === 'flight_hotel') return [QUESTIONS[0]].concat(getFlightRouteQuestions());
    if (path === 'hotel') return [QUESTIONS[0]].concat(HOTEL_QUESTIONS);
    if (path === 'self' || path === 'unsure') return [QUESTIONS[0]].concat(UNSURE_QUESTIONS);

    return QUESTIONS.filter((question) => !question.conditional || question.conditional(answers));
  }

  function getFlightRouteQuestions() {
    return ['flight_length', 'flight_main_needs', 'flight_seat_reality', 'flight_onboard_carry']
      .map((id) => FLIGHT_QUESTIONS.find((question) => question.id === id))
      .filter(Boolean);
  }

  function isGiftPath(answers) {
    return answers.first_intent === 'gift' || (!answers.first_intent && GIFT_USER_VALUES.has(answers.user_for_whom));
  }

  function isFlightPath(answers) {
    return answers.first_intent === 'flight' || answers.first_intent === 'flight_hotel' || (!answers.first_intent && !isGiftPath(answers) && answers.personal_travel_style === 'flights_sitting');
  }

  function isHotelPath(answers) {
    return answers.first_intent === 'hotel';
  }

  function isHybridPath(answers) {
    return answers.first_intent === 'flight_hotel';
  }

  function buildResult(state) {
    const candidates = getScoredCandidates(state);
    const primary = selectPrimaryCandidate(candidates, state.answers);
    const promotedPrimary = maybePromoteBundle(primary, candidates, state.answers) || primary;
    const tradeoff = detectTradeoff(promotedPrimary, candidates, state.answers);
    const finalPrimary = tradeoff.primary || promotedPrimary;
    const alternative = selectAlternative(finalPrimary, candidates, state.answers, tradeoff);
    const addOns = selectAddOns(finalPrimary, state.answers, state.liveAccessories);
    const confidence = getConfidence(finalPrimary.score, alternative && alternative.score);
    const result = {
      id: `${finalPrimary.id}_${tradeoff.state || 'standard'}`,
      primary: finalPrimary,
      alternative,
      addOns,
      tradeoff,
      confidence,
      scorePrimary: finalPrimary.score,
      scoreAlternative: alternative ? alternative.score : null
    };

    const resultProperties = getResultProperties(state, result);
    track(state, 'Snoooze Quiz Completed', resultProperties);
    if (isGiftPath(state.answers)) {
      track(state, 'Snoooze Quiz Gift Completed', resultProperties);
    }
    if (isFlightPath(state.answers)) {
      track(state, 'Snoooze Quiz Flight Completed', resultProperties);
    }
    track(state, 'Snoooze Quiz Result Viewed', resultProperties);
    window.dispatchEvent(new CustomEvent('snoooze:pillow_quiz_completed', {
      detail: {
        path: getPathProperties(state.answers).path,
        recommended_product_type: effectiveFamily(finalPrimary),
        result_id: result.id,
        primary_product_handle: finalPrimary.handle
      }
    }));

    return result;
  }

  function getScoredCandidates(state) {
    const hardFilters = getHardFilters(state.answers);
    return PRODUCT_RECORDS
      .filter((record) => record.available)
      .filter((record) => !EXCLUDED_PRODUCT_IDS.has(record.id))
      .filter((record) => passesHardFilters(record, hardFilters))
      .map((record) => {
        const score = scoreProduct(record, state.answers);
        return Object.assign({}, record, { score });
      })
      .filter((record) => record.family !== 'bundle_offer' || record.score > -50)
      .sort((a, b) => b.score - a.score);
  }

  function getHardFilters(answers) {
    const material = isGiftPath(answers)
      ? (answers.gift_material_avoidance || [])
      : (isFlightPath(answers) ? (answers.flight_main_needs || []) : (answers.personal_material_practical_needs || []));
    return {
      avoidDown: material.includes('avoid_down') || (isGiftPath(answers) && material.includes('safe_unknown')),
      avoidLatex: material.includes('avoid_latex'),
      veryLittleLuggage: answers.personal_luggage === 'backpack' ||
        answers.flight_onboard_carry === 'personal_bag' ||
        answers.gift_packing_style === 'small_bag' ||
        answers.gift_packing_style === 'unknown_easy',
      flightRoute: isFlightPath(answers) ||
        ['flights_sitting', 'travel_and_hotel'].includes(answers.personal_travel_style) ||
        ['flights_sitting', 'travel_and_hotel'].includes(answers.gift_travel_type)
    };
  }

  function passesHardFilters(record, filters) {
    if (record.family === 'bundle_offer') return true;
    if (filters.flightRoute && record.family === 'large') return false;
    if (filters.avoidDown && record.containsFeatherDown) return false;
    if (filters.avoidLatex && record.containsLatex) return false;
    if (filters.veryLittleLuggage && record.family === 'large') return false;
    return true;
  }

  function scoreProduct(record, answers) {
    if (record.family === 'bundle_offer') {
      return scoreBundle(record, answers);
    }

    if (isGiftPath(answers)) {
      return scoreGiftProduct(record, answers);
    }

    if (isFlightPath(answers)) {
      return scoreFlightProduct(record, answers);
    }

    let score = 0;
    const material = answers.personal_material_practical_needs || [];
    const problems = answers.personal_sleep_away_problem || [];
    const has = (profile) => record.profile.includes(profile);
    const luggage = answers.personal_luggage;
    const travel = answers.personal_travel_style;
    const feel = answers.personal_pillow_feel;
    const resultPreference = answers.personal_result_preference;
    const wantsSilk = material.includes('skin_hair_hot');
    const wantsLowEffort = material.includes('low_effort_packing');
    const tripLength = answers.hotel_trip_length;

    if (tripLength === 'one_two_nights' || tripLength === 'weekend_short') {
      score += record.family === 'mini' ? 2 : 0;
      score += ['mini_snoooze', 'full_size_snoooze'].includes(record.id) ? 2 : 0;
    }
    if (tripLength === 'week_or_more' || tripLength === 'frequent_hotels') {
      score += record.family === 'full_portable' ? 4 : 0;
      score += ['adaptgo', 'full_size_snoooze', 'goose_flat_full'].includes(record.id) ? 2 : 0;
    }
    if (tripLength === 'comfort_first') {
      score += record.family === 'large' ? 6 : 0;
      score += record.family === 'full_portable' ? 3 : 0;
    }

    if (answers.first_intent === 'self' || answers.first_intent === 'unsure') {
      score += ['mini_snoooze', 'full_size_snoooze'].includes(record.id) ? 4 : 0;
      score += record.id === 'all_silk_mini' && wantsSilk ? 5 : 0;
      score += record.id === 'adaptgo' && feel === 'adjustable' && !material.includes('avoid_latex') ? 5 : 0;
      score += record.family === 'large' && luggage !== 'extra_bag_ok' ? -8 : 0;
    }

    if (luggage === 'backpack') {
      score += record.family === 'mini' ? 10 : -4;
      score += record.id === 'goose_flat_full' && (feel === 'low_soft' || material.includes('natural_down')) ? 2 : 0;
      score += record.family === 'large' ? -99 : 0;
    }
    if (luggage === 'hand_luggage') {
      score += record.family === 'full_portable' ? 5 : 0;
      score += record.family === 'mini' ? 2 : 0;
      score += record.family === 'large' ? -8 : 0;
    }
    if (luggage === 'checked_luggage') {
      score += record.family === 'full_portable' ? 5 : 0;
      score += record.family === 'large' ? 1 : 0;
    }
    if (luggage === 'extra_bag_ok') {
      score += record.family === 'large' ? 7 : 0;
      score += record.family === 'full_portable' ? 3 : 0;
      score += record.family === 'mini' ? -2 : 0;
    }

    if (travel === 'flights_sitting') {
      score += record.family === 'mini' ? 4 : 0;
      score += ['mini_snoooze', 'goose_down_mini', 'supreme_3ch_mini'].includes(record.id) ? 3 : 0;
      score += record.family === 'full_portable' && luggage !== 'backpack' ? 3 : 0;
      score += ['full_size_snoooze', 'goose_down_full', 'supreme_3ch_full', 'adaptgo'].includes(record.id) && luggage !== 'backpack' ? 2 : 0;
    }
    if (travel === 'hotels_work') {
      score += record.family === 'full_portable' ? 5 : 0;
      score += ['full_size_snoooze', 'adaptgo', 'goose_flat_full', 'goose_down_full', 'supreme_3ch_full'].includes(record.id) ? 3 : 0;
      score += record.family === 'mini' && luggage === 'backpack' ? 3 : 0;
    }
    if (travel === 'travel_and_hotel') {
      score += record.family === 'full_portable' && luggage !== 'backpack' ? 6 : 0;
      score += record.family === 'mini' && luggage === 'backpack' ? 4 : 0;
      score += ['full_size_snoooze', 'adaptgo'].includes(record.id) ? 2 : 0;
    }
    if (travel === 'car_camper_long') {
      score += record.family === 'large' ? 8 : 0;
      score += record.family === 'full_portable' ? 3 : 0;
      score += ['large_goose_down', 'supreme_3ch_large'].includes(record.id) ? 3 : 0;
    }
    if (travel === 'safe_travel_choice') {
      score += record.id === 'mini_snoooze' ? 5 : 0;
      score += record.id === 'full_size_snoooze' && luggage !== 'backpack' ? 4 : 0;
      score += record.id === 'all_silk_mini' && wantsSilk ? 4 : 0;
      score += record.family === 'large' ? -6 : 0;
    }

    if (problems.includes('clean_surface')) {
      score += ['mini_snoooze', 'full_size_snoooze', 'goose_flat_full'].includes(record.id) ? 4 : 0;
      score += has('hygiene_surface') ? 2 : 0;
    }
    if (problems.includes('too_high_bulky_hard')) {
      score += ['goose_flat_full', 'goose_down_mini', 'mini_snoooze'].includes(record.id) ? 5 : 0;
      score += record.id === 'adaptgo' ? 3 : 0;
      score += has('structured') && feel !== 'more_supportive' ? -3 : 0;
    }
    if (problems.includes('too_low_flat_collapse')) {
      score += ['supreme_3ch_mini', 'supreme_3ch_full', 'supreme_3ch_large', 'adaptgo', 'full_size_snoooze'].includes(record.id) ? 5 : 0;
      score += record.family === 'full_portable' && luggage !== 'backpack' ? 2 : 0;
    }
    if (problems.includes('flight_sitting_sleep')) {
      score += record.family === 'mini' && luggage === 'backpack' ? 4 : 0;
      score += ['full_size_snoooze', 'goose_down_full', 'supreme_3ch_full'].includes(record.id) && luggage !== 'backpack' ? 4 : 0;
      score += record.id === 'adaptgo' && feel === 'adjustable' ? 3 : 0;
    }
    if (problems.includes('different_every_trip')) {
      score += record.id === 'adaptgo' ? 8 : 0;
      score += record.id === 'full_size_snoooze' ? 3 : 0;
      score += has('balanced') || has('adjustable') ? 2 : 0;
    }
    if (problems.includes('closer_to_home')) {
      score += record.family === 'large' ? 7 : 0;
      score += record.family === 'full_portable' ? 5 : 0;
      score += record.family === 'mini' && luggage === 'backpack' ? 1 : 0;
    }

    if (feel === 'low_soft') {
      score += ['goose_flat_full', 'goose_down_mini', 'mini_snoooze', 'adaptgo'].includes(record.id) ? 6 : 0;
      score += has('structured') && !problems.includes('too_low_flat_collapse') ? -4 : 0;
    }
    if (feel === 'soft_sink') {
      score += ['goose_down_mini', 'goose_down_full', 'full_size_snoooze'].includes(record.id) ? 6 : 0;
      score += has('very_soft') || has('soft') || has('natural_down') ? 2 : 0;
    }
    if (feel === 'balanced_medium') {
      score += record.id === 'full_size_snoooze' ? 7 : 0;
      score += ['goose_down_full', 'adaptgo'].includes(record.id) ? 3 : 0;
      score += record.id === 'all_silk_mini' && (luggage === 'backpack' || wantsSilk) ? 2 : 0;
    }
    if (feel === 'more_supportive') {
      score += ['supreme_3ch_mini', 'supreme_3ch_full', 'supreme_3ch_large', 'adaptgo'].includes(record.id) ? 8 : 0;
      score += has('structured') || has('supportive') ? 3 : 0;
    }
    if (feel === 'adjustable') {
      score += record.id === 'adaptgo' ? 11 : 0;
      score += ['full_size_snoooze', 'supreme_3ch_full'].includes(record.id) ? 2 : 0;
    }
    if (feel === 'not_sure') {
      score += record.id === 'mini_snoooze' && luggage === 'backpack' ? 5 : 0;
      score += record.id === 'full_size_snoooze' && luggage !== 'backpack' ? 6 : 0;
      score += ['goose_flat_full', 'supreme_3ch_large'].includes(record.id) ? -2 : 0;
    }

    if (material.includes('easy_care')) {
      score += ['mini_snoooze', 'full_size_snoooze'].includes(record.id) ? 5 : 0;
      score += ['all_silk_mini', 'adaptgo'].includes(record.id) ? -3 : 0;
    }
    if (material.includes('natural_down')) {
      score += ['goose_down_mini', 'goose_flat_full', 'goose_down_full', 'large_goose_down'].includes(record.id) ? 7 : 0;
      score += record.id.includes('supreme_3ch') ? 2 : 0;
    }
    if (wantsSilk) {
      score += record.id === 'all_silk_mini' && luggage === 'backpack' ? 8 : 0;
      score += record.id === 'all_silk_mini' && !['more_supportive', 'adjustable'].includes(feel) && !problems.includes('closer_to_home') ? 4 : 0;
      score += record.family === 'full_portable' && (problems.includes('too_low_flat_collapse') || problems.includes('closer_to_home')) ? 1 : 0;
    }
    if (wantsLowEffort) {
      score += record.velcroBagIncluded ? 3 : 0;
      score += record.family === 'mini' ? 1 : 0;
      score += ['mini_snoooze', 'full_size_snoooze'].includes(record.id) ? 1 : 0;
    }

    if (resultPreference === 'best_value_first') {
      score += ['mini_snoooze', 'full_size_snoooze'].includes(record.id) ? 7 : 0;
      if (record.fallbackPrice > 70) score -= 4;
    }
    if (resultPreference === 'premium_upgrade') {
      score += has('premium') || has('natural_down') || record.id === 'adaptgo' ? 2 : 0;
    }

    return score;
  }

  function scoreFlightProduct(record, answers) {
    let score = 0;
    const needs = answers.flight_main_needs || [];
    const useScope = answers.flight_use_scope;
    const length = answers.flight_length;
    const carry = answers.flight_onboard_carry;
    const seat = answers.flight_seat_reality;
    const has = (profile) => record.profile.includes(profile);
    const isLongFlight = ['six_plus', 'overnight', 'frequent'].includes(length);
    const carryAllowsFull = ['rolled_clipped', 'cabin_take_out'].includes(carry);

    if (record.family === 'large') return -999;

    if (carry === 'personal_bag') {
      score += record.family === 'mini' ? 11 : -6;
      score += record.id === 'goose_flat_full' && needs.includes('low_not_bulky') ? 2 : 0;
    }
    if (carry === 'rolled_clipped') {
      score += record.family === 'mini' ? 6 : 0;
      score += record.family === 'full_portable' ? 2 : 0;
      score += record.velcroBagIncluded ? 2 : 0;
    }
    if (carry === 'cabin_take_out') {
      score += record.family === 'full_portable' ? 6 : 0;
      score += record.family === 'mini' ? 2 : 0;
    }
    if (useScope === 'flight_only') {
      score += record.family === 'mini' ? 5 : 0;
      score += record.family === 'full_portable' && isLongFlight && carryAllowsFull ? 3 : 0;
    }
    if (useScope === 'flight_plus_hotel') {
      score += record.family === 'full_portable' && carry !== 'personal_bag' ? 7 : 0;
      score += record.family === 'mini' && carry === 'personal_bag' ? 4 : 0;
    }
    if (useScope === 'mostly_flight_hotel_bonus') {
      score += record.family === 'mini' ? 4 : 0;
      score += record.family === 'full_portable' && carryAllowsFull ? 3 : 0;
    }
    if (useScope === 'long_sitting') {
      score += record.family === 'mini' ? 5 : 0;
      score += ['mini_snoooze', 'goose_down_mini', 'supreme_3ch_mini', 'adaptgo'].includes(record.id) ? 4 : 0;
    }

    if (length === 'under_3') {
      score += record.family === 'mini' ? 6 : 0;
      score += record.family === 'full_portable' && useScope !== 'flight_plus_hotel' ? -2 : 0;
      score += ['mini_snoooze', 'all_silk_mini', 'goose_down_mini'].includes(record.id) ? 2 : 0;
    }
    if (length === 'three_to_six') {
      score += record.family === 'mini' ? 4 : 0;
      score += record.family === 'full_portable' && carryAllowsFull ? 1 : 0;
    }
    if (length === 'six_plus') {
      score += record.family === 'full_portable' && carryAllowsFull ? 6 : 0;
      score += record.family === 'mini' && carry === 'personal_bag' ? 3 : 0;
    }
    if (length === 'overnight') {
      score += record.family === 'full_portable' && carryAllowsFull ? 8 : 0;
      score += record.family === 'mini' && carry === 'personal_bag' ? 3 : 0;
    }
    if (length === 'frequent') {
      score += ['mini_snoooze', 'full_size_snoooze'].includes(record.id) ? 4 : 0;
      score += record.velcroBagIncluded ? 2 : 0;
      score += has('easy_care') ? 2 : 0;
    }

    if (seat === 'window') {
      score += record.family === 'full_portable' && isLongFlight && carryAllowsFull ? 4 : 0;
      score += record.family === 'mini' ? 2 : 0;
      score += ['supreme_3ch_mini', 'supreme_3ch_full'].includes(record.id) ? 2 : 0;
    }
    if (seat === 'aisle_middle') {
      score += record.family === 'mini' ? 4 : 0;
      score += ['supreme_3ch_mini', 'adaptgo', 'mini_snoooze'].includes(record.id) ? 3 : 0;
      score += record.family === 'full_portable' && carryAllowsFull ? 1 : 0;
    }
    if (seat === 'lie_flat') {
      score += ['all_silk_mini', 'goose_down_mini', 'goose_flat_full', 'full_size_snoooze', 'goose_down_full'].includes(record.id) ? 4 : 0;
      score += record.family === 'full_portable' && carryAllowsFull ? 2 : 0;
    }
    if (seat === 'changes_unknown') {
      score += record.id === 'mini_snoooze' ? 4 : 0;
      score += record.id === 'supreme_3ch_mini' ? 3 : 0;
      score += record.id === 'adaptgo' ? 3 : 0;
      score += record.id === 'full_size_snoooze' && carryAllowsFull ? 2 : 0;
    }

    if (needs.includes('clean_surface')) {
      score += ['mini_snoooze', 'full_size_snoooze', 'goose_flat_full'].includes(record.id) ? 5 : 0;
      score += has('hygiene_surface') ? 2 : 0;
    }
    if (needs.includes('soft_comfort')) {
      score += ['goose_down_mini', 'goose_down_full', 'full_size_snoooze', 'all_silk_mini'].includes(record.id) ? 6 : 0;
      score += has('soft') || has('very_soft') || has('natural_down') ? 2 : 0;
    }
    if (needs.includes('more_support')) {
      score += ['supreme_3ch_mini', 'supreme_3ch_full', 'adaptgo'].includes(record.id) ? 8 : 0;
      score += record.id === 'supreme_3ch_mini' && carry === 'personal_bag' ? 3 : 0;
      score += has('structured') || has('supportive') ? 3 : 0;
    }
    if (needs.includes('low_not_bulky')) {
      score += ['mini_snoooze', 'goose_down_mini', 'goose_flat_full'].includes(record.id) ? 6 : 0;
      score += ['supreme_3ch_full', 'goose_down_full'].includes(record.id) ? -4 : 0;
    }
    if (needs.includes('skin_hair_hot')) {
      score += record.id === 'all_silk_mini' && record.family === 'mini' ? 9 : 0;
      score += record.family === 'full_portable' && (isLongFlight || useScope === 'flight_plus_hotel') && carryAllowsFull ? 1 : 0;
    }
    if (needs.includes('easy_care')) {
      score += ['mini_snoooze', 'full_size_snoooze'].includes(record.id) ? 6 : 0;
      score += ['all_silk_mini', 'adaptgo'].includes(record.id) ? -3 : 0;
    }
    if (needs.includes('low_effort_packing')) {
      score += record.velcroBagIncluded ? 4 : 0;
      score += ['mini_snoooze', 'full_size_snoooze'].includes(record.id) ? 1 : 0;
    }
    if (needs.includes('best_value')) {
      score += ['mini_snoooze', 'full_size_snoooze'].includes(record.id) ? 8 : 0;
      if (record.fallbackPrice > 70) score -= 4;
    }

    return score;
  }

  function scoreGiftProduct(record, answers) {
    let score = 0;
    const material = answers.gift_material_avoidance || [];
    const has = (profile) => record.profile.includes(profile);
    const safeUnknown = material.includes('safe_unknown');

    if (answers.user_for_whom === 'gift_young') {
      score += record.family === 'mini' ? 7 : -3;
      score += record.id === 'mini_snoooze' ? 4 : 0;
      score += record.id === 'all_silk_mini' ? 3 : 0;
      score += record.id === 'goose_down_mini' && !safeUnknown ? 2 : 0;
    }
    if (answers.user_for_whom === 'gift_adult') {
      score += record.family === 'mini' ? 1 : 0;
      score += record.family === 'full_portable' ? 3 : 0;
      score += ['full_size_snoooze', 'adaptgo', 'goose_down_full', 'goose_flat_full', 'supreme_3ch_full'].includes(record.id) ? 2 : 0;
    }
    if (answers.user_for_whom === 'gift_parent') {
      score += record.family === 'full_portable' ? 4 : 0;
      score += ['full_size_snoooze', 'adaptgo', 'goose_flat_full'].includes(record.id) ? 3 : 0;
      score += record.family === 'mini' && answers.gift_packing_style === 'unknown_easy' ? 3 : 0;
    }
    if (answers.user_for_whom === 'gift_couple') {
      score += record.id === 'adaptgo' ? 8 : 0;
      score += record.family === 'mini' && ['small_bag', 'unknown_easy'].includes(answers.gift_packing_style) ? 3 : 0;
      score += record.id === 'full_size_snoooze' ? 2 : 0;
    }
    if (answers.user_for_whom === 'gift_unsure') {
      score += record.id === 'mini_snoooze' ? 8 : 0;
      score += record.id === 'all_silk_mini' ? 5 : 0;
      score += record.id === 'goose_down_mini' && !safeUnknown ? 2 : 0;
      score += record.family === 'large' ? -8 : 0;
    }

    if (answers.gift_travel_type === 'flights_sitting') {
      score += record.family === 'mini' ? 4 : 0;
      score += ['mini_snoooze', 'goose_down_mini', 'supreme_3ch_mini'].includes(record.id) ? 3 : 0;
      score += record.id === 'full_size_snoooze' && answers.gift_packing_style !== 'small_bag' ? 3 : 0;
      score += record.id === 'adaptgo' && answers.user_for_whom !== 'gift_young' ? 2 : 0;
    }
    if (answers.gift_travel_type === 'hotels_work') {
      score += record.family === 'full_portable' ? 5 : 0;
      score += ['full_size_snoooze', 'adaptgo', 'goose_down_full', 'supreme_3ch_full'].includes(record.id) ? 3 : 0;
      score += record.family === 'mini' && answers.gift_packing_style === 'unknown_easy' ? 2 : 0;
    }
    if (answers.gift_travel_type === 'travel_and_hotel') {
      score += record.family === 'full_portable' ? 5 : 0;
      score += record.family === 'mini' && ['small_bag', 'unknown_easy'].includes(answers.gift_packing_style) ? 4 : 0;
      score += ['full_size_snoooze', 'adaptgo'].includes(record.id) ? 2 : 0;
    }
    if (answers.gift_travel_type === 'car_camper_long') {
      score += record.family === 'large' ? 7 : 0;
      score += record.family === 'full_portable' ? 3 : 0;
      score += ['large_goose_down', 'supreme_3ch_large'].includes(record.id) ? 3 : 0;
    }
    if (answers.gift_travel_type === 'safe_travel_gift') {
      score += record.id === 'mini_snoooze' ? 6 : 0;
      score += record.id === 'all_silk_mini' ? 4 : 0;
      score += record.family === 'large' ? -6 : 0;
    }

    if (answers.gift_packing_style === 'small_bag') {
      score += record.family === 'mini' ? 8 : -4;
      score += record.family === 'large' ? -99 : 0;
    }
    if (answers.gift_packing_style === 'cabin_weekender') {
      score += record.family === 'full_portable' ? 5 : 0;
      score += record.family === 'mini' ? 2 : 0;
      score += record.family === 'large' ? -5 : 0;
    }
    if (answers.gift_packing_style === 'checked_extra') {
      score += record.family === 'large' ? 5 : 0;
      score += record.family === 'full_portable' ? 4 : 0;
    }
    if (answers.gift_packing_style === 'unknown_easy') {
      score += record.family === 'mini' ? 7 : 0;
      score += record.id === 'mini_snoooze' ? 3 : 0;
      score += record.id === 'all_silk_mini' ? 2 : 0;
      score += record.family === 'large' ? -99 : 0;
    }

    if (answers.gift_feeling === 'practical') {
      score += ['mini_snoooze', 'full_size_snoooze'].includes(record.id) ? 6 : 0;
      score += has('easy_care') ? 2 : 0;
    }
    if (answers.gift_feeling === 'soft_cosy') {
      score += ['goose_down_mini', 'goose_down_full', 'full_size_snoooze'].includes(record.id) ? 6 : 0;
      score += has('very_soft') || has('soft') || has('natural_down') ? 2 : 0;
    }
    if (answers.gift_feeling === 'premium_special') {
      score += ['all_silk_mini', 'goose_down_mini', 'goose_down_full', 'large_goose_down'].includes(record.id) ? 6 : 0;
      score += has('premium') ? 3 : 0;
    }
    if (answers.gift_feeling === 'skin_hair_hot') {
      score += record.id === 'all_silk_mini' ? 9 : 0;
      score += record.family === 'full_portable' && answers.gift_packing_style !== 'small_bag' ? 2 : 0;
      score += has('silk') ? 5 : 0;
    }
    if (answers.gift_feeling === 'supportive_substantial') {
      score += ['supreme_3ch_mini', 'supreme_3ch_full', 'supreme_3ch_large'].includes(record.id) ? 8 : 0;
      score += record.id === 'adaptgo' ? 5 : 0;
      score += has('structured') ? 3 : 0;
    }

    if (material.includes('easy_washable')) {
      score += ['mini_snoooze', 'full_size_snoooze'].includes(record.id) ? 5 : 0;
      score += ['all_silk_mini', 'adaptgo'].includes(record.id) ? -3 : 0;
    }
    if (material.includes('natural_down')) {
      score += ['goose_down_mini', 'goose_flat_full', 'goose_down_full', 'large_goose_down'].includes(record.id) ? 7 : 0;
      score += record.id.includes('supreme_3ch') ? 2 : 0;
    }
    if (safeUnknown) {
      score += ['mini_snoooze', 'full_size_snoooze', 'all_silk_mini', 'adaptgo'].includes(record.id) ? 3 : 0;
      score += record.containsFeatherDown ? -5 : 0;
    }

    if (answers.gift_price_preference === 'value_gift') {
      score += ['mini_snoooze', 'full_size_snoooze'].includes(record.id) ? 8 : 0;
      if (record.fallbackPrice > 70) score -= 3;
    }
    if (answers.gift_price_preference === 'balanced_gift') {
      score += ['supreme_3ch_mini', 'full_size_snoooze', 'adaptgo', 'goose_down_mini', 'goose_flat_full'].includes(record.id) ? 5 : 0;
    }
    if (answers.gift_price_preference === 'premium_gift') {
      score += ['all_silk_mini', 'goose_down_full', 'supreme_3ch_full', 'large_goose_down', 'supreme_3ch_large'].includes(record.id) ? 6 : 0;
      score += has('premium') ? 2 : 0;
    }

    return score;
  }

  function scoreBundle(record, answers) {
    return -60;
  }

  function selectPrimaryCandidate(candidates, answers) {
    const tradeoff = detectCompactTradeoff(candidates, answers);
    if (tradeoff.primary) return tradeoff.primary;

    const pillow = candidates.find((record) => record.family !== 'bundle_offer');
    if (pillow) return pillow;

    return candidates[0];
  }

  function maybePromoteBundle(primary, candidates, answers) {
    return null;
  }

  function detectTradeoff(primary, candidates, answers) {
    const compactTradeoff = detectCompactTradeoff(candidates, answers);
    if (compactTradeoff.primary) return compactTradeoff;

    if (isFlightPath(answers)) {
      return detectFlightTradeoff(primary, answers);
    }

    if (primary.family === 'large') {
      return { state: 'large_comfort_first', label: 'Comfort-first match', primary };
    }

    if (!isGiftPath(answers) && (answers.personal_material_practical_needs || []).includes('skin_hair_hot') && primary.family === 'full_portable') {
      return { state: 'skin_hair_full_support', label: 'Support first, silk as the upgrade', primary };
    }

    if (!isGiftPath(answers) && answers.personal_luggage === 'backpack' && (answers.personal_sleep_away_problem || []).includes('closer_to_home')) {
      return { state: 'backpack_home_comfort', label: 'Your best compact compromise', primary };
    }

    return { state: '', label: '', primary };
  }

  function detectFlightTradeoff(primary, answers) {
    const needs = answers.flight_main_needs || [];
    const isLongFlight = ['six_plus', 'overnight', 'frequent'].includes(answers.flight_length);

    if (answers.flight_onboard_carry === 'personal_bag' && isLongFlight && primary.family === 'mini') {
      return { state: 'compact_flight_match', label: 'Your best compact flight match', primary };
    }

    if (answers.flight_seat_reality === 'aisle_middle') {
      return { state: 'middle_aisle_reality', label: 'Flight seat reality', primary };
    }

    if (['flight_plus_hotel', 'mostly_flight_hotel_bonus'].includes(answers.flight_use_scope)) {
      return { state: 'flight_hotel_case', label: 'Flight plus hotel match', primary };
    }

    if (needs.includes('skin_hair_hot') && primary.family === 'full_portable') {
      return { state: 'skin_hair_flight_support', label: 'Support first, silk as the upgrade', primary };
    }

    return { state: '', label: '', primary };
  }

  function detectCompactTradeoff(candidates, answers) {
    if (isGiftPath(answers)) {
      return { state: '', label: '', primary: null };
    }

    const material = answers.personal_material_practical_needs || [];
    const problems = answers.personal_sleep_away_problem || [];
    const wantsHomeComfort = problems.includes('closer_to_home');
    const wantsSupport = answers.personal_pillow_feel === 'more_supportive' || problems.includes('too_low_flat_collapse');
    if (answers.personal_luggage !== 'backpack' || (!wantsHomeComfort && !wantsSupport)) {
      return { state: '', label: '', primary: null };
    }

    const downAllowed = !material.includes('avoid_down');
    const latexAllowed = !material.includes('avoid_latex');
    let compactIds = [];
    let betterIds = [];

    if (downAllowed && wantsSupport) {
      compactIds = ['supreme_3ch_mini', 'goose_down_mini', 'mini_snoooze'];
      betterIds = ['supreme_3ch_full', 'full_size_snoooze'];
    } else if (downAllowed && wantsHomeComfort) {
      compactIds = ['goose_down_mini', 'mini_snoooze', 'supreme_3ch_mini'];
      betterIds = ['goose_down_full', 'full_size_snoooze'];
    } else if (latexAllowed) {
      compactIds = ['mini_snoooze'];
      betterIds = ['adaptgo', 'full_size_snoooze'];
    } else {
      compactIds = ['mini_snoooze'];
      betterIds = ['full_size_snoooze'];
    }

    const primary = findFirstByIds(candidates, compactIds);
    const alternative = findFirstByIds(candidates, betterIds);
    return {
      state: 'compact_compromise',
      label: 'Your best compact compromise',
      primary,
      forcedAlternative: alternative
    };
  }

  function selectAlternative(primary, candidates, answers, tradeoff) {
    if (!primary) return null;
    if (tradeoff && tradeoff.forcedAlternative && tradeoff.forcedAlternative.id !== primary.id) {
      return Object.assign({}, tradeoff.forcedAlternative, {
        alternativeLabel: 'Better if you can spare more room',
        tradeoffCopy: 'It should sleep better for your support need, but it needs more packing space.'
      });
    }

    if (isGiftPath(answers)) {
      return selectGiftAlternative(primary, candidates, answers);
    }

    if (isFlightPath(answers)) {
      return selectFlightAlternative(primary, candidates, answers);
    }

    const material = answers.personal_material_practical_needs || [];
    const resultPreference = answers.personal_result_preference;
    let ids = [];
    let label = '';
    let copy = '';

    if (resultPreference === 'best_match_only') {
      return null;
    }

    if (resultPreference === 'best_plus_lower') {
      ids = getValueAlternatives(primary);
      label = 'Better price';
      copy = 'This costs less, but the feel, size, or support is a compromise.';
    } else if (resultPreference === 'premium_upgrade') {
      ids = getPremiumAlternatives(primary, answers);
      label = getPremiumAlternativeLabel(primary, answers);
      copy = 'This is useful only if the upgraded feel, surface, or support matters more than the simpler match.';
    } else if (material.includes('skin_hair_hot') && !primary.profile.includes('silk') && primary.family === 'mini') {
      ids = ['all_silk_mini'];
      label = 'Premium silk option';
      copy = 'This is useful if compact silk matters more than the simpler compact match.';
    } else {
      return null;
    }

    const alternative = findFirstByIds(candidates, ids);
    if (!alternative || alternative.id === primary.id) return null;
    if (resultPreference !== 'best_plus_lower' && Math.abs(primary.score - alternative.score) > 16) return null;

    return Object.assign({}, alternative, {
      alternativeLabel: label,
      tradeoffCopy: copy
    });
  }

  function selectFlightAlternative(primary, candidates, answers) {
    const needs = answers.flight_main_needs || [];
    const isLongFlight = ['six_plus', 'overnight', 'frequent'].includes(answers.flight_length);
    const carryAllowsFull = ['rolled_clipped', 'cabin_take_out'].includes(answers.flight_onboard_carry);
    let ids = [];
    let label = '';
    let copy = '';

    if (needs.includes('best_value')) {
      ids = getValueAlternatives(primary);
      label = 'Better price';
      copy = 'This costs less, but the feel, size, or support is a compromise.';
    } else if (primary.family === 'mini' && isLongFlight && carryAllowsFull) {
      if (needs.includes('more_support')) {
        ids = ['supreme_3ch_full', 'adaptgo', 'full_size_snoooze'];
        label = 'More comfort if you can carry it';
      } else if (needs.includes('avoid_down')) {
        ids = ['full_size_snoooze', 'adaptgo'];
        label = 'More surface if you can carry it';
      } else {
        ids = ['full_size_snoooze', 'goose_down_full', 'goose_flat_full'];
        label = 'More comfort if you can carry it';
      }
      copy = 'This gives more pillow surface for longer flights, but it needs more carry-on space.';
    } else if (needs.includes('skin_hair_hot') && primary.id !== 'all_silk_mini' && primary.family === 'mini') {
      ids = ['all_silk_mini'];
      label = 'Premium silk option';
      copy = 'This is useful if compact silk matters more than the simpler compact match.';
    } else if (needs.includes('more_support') && primary.id === 'mini_snoooze') {
      ids = ['supreme_3ch_mini', 'adaptgo'];
      label = 'More support';
      copy = 'This gives more hold, but it may cost more or need more packing space.';
    } else {
      return null;
    }

    const alternative = findFirstByIds(candidates, ids);
    if (!alternative || alternative.id === primary.id) return null;

    return Object.assign({}, alternative, {
      alternativeLabel: label,
      tradeoffCopy: copy
    });
  }

  function selectGiftAlternative(primary, candidates, answers) {
    let ids = [];
    let label = '';
    let copy = '';

    if (answers.gift_price_preference === 'best_plus_lower') {
      ids = getGiftValueAlternatives(primary);
      label = 'Better price';
      copy = 'This costs less, but the feel, size, or support is a compromise.';
    } else if (answers.gift_feeling === 'skin_hair_hot' && primary.id !== 'all_silk_mini') {
      ids = ['all_silk_mini'];
      label = 'Premium compact silk option';
      copy = 'This is better if the gift should feel smoother and more premium, but it gives less pillow surface.';
    } else if (answers.gift_feeling === 'supportive_substantial' && primary.family === 'mini' && answers.gift_packing_style !== 'small_bag') {
      ids = ['supreme_3ch_full', 'adaptgo'];
      label = 'More support';
      copy = 'This gives more pillow surface or flexibility, but needs more packing space.';
    }

    const alternative = findFirstByIds(candidates, ids);
    if (!alternative || alternative.id === primary.id) return null;

    return Object.assign({}, alternative, {
      alternativeLabel: label,
      tradeoffCopy: copy
    });
  }

  function getGiftValueAlternatives(primary) {
    const map = {
      all_silk_mini: ['mini_snoooze'],
      goose_down_mini: ['mini_snoooze'],
      supreme_3ch_mini: ['mini_snoooze'],
      adaptgo: ['full_size_snoooze', 'mini_snoooze'],
      goose_flat_full: ['full_size_snoooze', 'mini_snoooze'],
      goose_down_full: ['full_size_snoooze'],
      supreme_3ch_full: ['full_size_snoooze'],
      large_goose_down: ['goose_down_full', 'full_size_snoooze'],
      supreme_3ch_large: ['supreme_3ch_full', 'full_size_snoooze']
    };
    return map[primary.id] || [];
  }

  function getValueAlternatives(primary) {
    const map = {
      all_silk_mini: ['mini_snoooze'],
      goose_down_mini: ['mini_snoooze'],
      supreme_3ch_mini: ['mini_snoooze'],
      goose_flat_full: ['mini_snoooze', 'full_size_snoooze'],
      goose_down_full: ['full_size_snoooze'],
      supreme_3ch_full: ['full_size_snoooze'],
      large_goose_down: ['goose_down_full', 'full_size_snoooze'],
      supreme_3ch_large: ['supreme_3ch_full', 'full_size_snoooze'],
      adaptgo: ['full_size_snoooze']
    };
    return map[primary.id] || [];
  }

  function getPremiumAlternatives(primary, answers) {
    const material = answers.personal_material_practical_needs || [];
    const map = {
      mini_snoooze: material.includes('skin_hair_hot') ? ['all_silk_mini'] : (answers.personal_pillow_feel === 'more_supportive' ? ['supreme_3ch_mini'] : ['goose_down_mini', 'all_silk_mini']),
      goose_down_mini: ['supreme_3ch_mini'],
      supreme_3ch_mini: ['supreme_3ch_full'],
      full_size_snoooze: answers.personal_pillow_feel === 'adjustable' ? ['adaptgo'] : (answers.personal_pillow_feel === 'more_supportive' ? ['supreme_3ch_full'] : ['goose_down_full', 'adaptgo']),
      goose_flat_full: ['goose_down_full'],
      goose_down_full: answers.personal_pillow_feel === 'more_supportive' ? ['supreme_3ch_full'] : ['large_goose_down'],
      supreme_3ch_full: answers.personal_luggage === 'extra_bag_ok' ? ['supreme_3ch_large'] : [],
      large_goose_down: ['supreme_3ch_large'],
      supreme_3ch_large: ['large_goose_down']
    };
    return map[primary.id] || [];
  }

  function getPremiumAlternativeLabel(primary, answers) {
    if (answers.personal_pillow_feel === 'more_supportive') return 'More support';
    if ((answers.personal_material_practical_needs || []).includes('skin_hair_hot')) return 'Premium silk option';
    if ((answers.personal_material_practical_needs || []).includes('natural_down')) return 'Softer natural upgrade';
    if (answers.personal_luggage === 'extra_bag_ok') return 'Closest to home';
    return 'Premium upgrade';
  }

  function getSupportAlternatives(primary, answers) {
    const map = {
      mini_snoooze: answers.personal_pillow_feel === 'more_supportive' ? ['supreme_3ch_mini'] : ['all_silk_mini'],
      all_silk_mini: ['mini_snoooze'],
      goose_down_mini: ['supreme_3ch_mini'],
      supreme_3ch_mini: ['supreme_3ch_full'],
      full_size_snoooze: ['adaptgo', 'supreme_3ch_full'],
      adaptgo: ['full_size_snoooze'],
      goose_flat_full: ['goose_down_full'],
      goose_down_full: ['supreme_3ch_full'],
      supreme_3ch_full: ['supreme_3ch_mini'],
      large_goose_down: ['goose_down_full'],
      supreme_3ch_large: ['supreme_3ch_full']
    };
    return map[primary.id] || [];
  }

  function getSupportAlternativeLabel(primary, answers) {
    if (answers.personal_luggage === 'backpack') return 'Better if you can spare more room';
    if (answers.personal_pillow_feel === 'more_supportive') return 'More support';
    if (answers.personal_pillow_feel === 'soft_sink') return 'Softer natural upgrade';
    return 'Useful alternative';
  }

  function selectAddOns(primary, answers) {
    if (!primary) return [];
    if (isGiftPath(answers)) return selectGiftAddOns(primary, answers);
    if (isFlightPath(answers)) return selectFlightAddOns(primary, answers);

    const addOns = [];
    const family = effectiveFamily(primary);
    const material = answers.personal_material_practical_needs || [];
    const problems = answers.personal_sleep_away_problem || [];
    const needsSpareCase = answers.first_intent === 'flight_hotel' ||
      answers.personal_travel_style === 'travel_and_hotel' ||
      answers.personal_travel_style === 'hotels_work' ||
      answers.personal_travel_style === 'car_camper_long' ||
      ['week_or_more', 'frequent_hotels', 'comfort_first'].includes(answers.hotel_trip_length) ||
      problems.includes('clean_surface');
    const wantsSilk = material.includes('skin_hair_hot');
    const wantsEasyPack = material.includes('low_effort_packing');

    if (family === 'large') {
      addAddOn(addOns, 'large_standard_case', primary, 'Required reminder');
    } else if (needsSpareCase && primary.pillowcaseIncluded) {
      addAddOn(addOns, family === 'mini' ? 'mini_cotton_case' : 'full_cotton_case', primary, 'Clean case for journey and bed');
    }

    if (wantsSilk) {
      if (primary.id === 'all_silk_mini') {
        if (needsSpareCase) addAddOn(addOns, 'mini_silk_case', primary, 'Spare silk case for frequent travel');
      } else if (family === 'mini') {
        addAddOn(addOns, 'mini_silk_case', primary, 'Smoother surface');
      } else if (family === 'full_portable' && !primary.id.includes('silk_bundle')) {
        addAddOn(addOns, 'full_silk_case', primary, 'Smoother surface');
      }
    }

    if (wantsEasyPack && ['mini_snoooze', 'full_size_snoooze'].includes(getBaseProductId(primary))) {
      addAddOn(addOns, 'easypack', primary, 'Low-effort packing');
    }

    return uniqueAddOns(addOns).slice(0, 2);
  }

  function selectFlightAddOns(primary, answers) {
    const addOns = [];
    const family = effectiveFamily(primary);
    const needs = answers.flight_main_needs || [];
    const needsSpareCase = answers.first_intent === 'flight_hotel' ||
      ['flight_plus_hotel', 'mostly_flight_hotel_bonus'].includes(answers.flight_use_scope) ||
      needs.includes('clean_surface');
    const wantsSilk = needs.includes('skin_hair_hot');
    const wantsEasyPack = needs.includes('low_effort_packing');

    if (family === 'large') {
      addAddOn(addOns, 'large_standard_case', primary, 'Required reminder');
    } else if (needsSpareCase && primary.pillowcaseIncluded) {
      addAddOn(addOns, family === 'mini' ? 'mini_cotton_case' : 'full_cotton_case', primary, 'Clean case for flight and bed');
    }

    if (wantsSilk) {
      if (primary.id === 'all_silk_mini') {
        if (needsSpareCase) addAddOn(addOns, 'mini_silk_case', primary, 'Spare silk case for flight and bed');
      } else if (family === 'mini') {
        addAddOn(addOns, 'mini_silk_case', primary, 'Smoother surface');
      } else if (family === 'full_portable') {
        addAddOn(addOns, 'full_silk_case', primary, 'Smoother surface');
      }
    }

    if (wantsEasyPack && ['mini_snoooze', 'full_size_snoooze'].includes(getBaseProductId(primary))) {
      addAddOn(addOns, 'easypack', primary, 'Low-effort packing');
    }

    return uniqueAddOns(addOns).slice(0, 2);
  }

  function selectGiftAddOns(primary, answers) {
    const addOns = [];
    const family = effectiveFamily(primary);
    const material = answers.gift_material_avoidance || [];
    const needsSpareCase = ['travel_and_hotel', 'hotels_work', 'car_camper_long'].includes(answers.gift_travel_type) ||
      answers.gift_feeling === 'practical' ||
      answers.gift_feeling === 'premium_special';
    const wantsSilk = answers.gift_feeling === 'skin_hair_hot';
    const wantsEasyPack = answers.user_for_whom === 'gift_parent' ||
      answers.gift_packing_style === 'unknown_easy' ||
      answers.gift_price_preference === 'value_gift';

    if (family === 'large') {
      addAddOn(addOns, 'large_standard_case', primary, 'Required reminder');
    } else if (needsSpareCase && primary.pillowcaseIncluded) {
      addAddOn(addOns, family === 'mini' ? 'mini_cotton_case' : 'full_cotton_case', primary, 'Journey and bed case');
    }

    if (wantsSilk) {
      if (primary.id === 'all_silk_mini') {
        if (needsSpareCase) addAddOn(addOns, 'mini_silk_case', primary, 'Spare silk case for frequent travel');
      } else if (family === 'mini') {
        addAddOn(addOns, 'mini_silk_case', primary, 'Smoother gift surface');
      } else if (family === 'full_portable') {
        addAddOn(addOns, 'full_silk_case', primary, 'Smoother gift surface');
      }
    }

    if (wantsEasyPack && ['mini_snoooze', 'full_size_snoooze'].includes(getBaseProductId(primary))) {
      addAddOn(addOns, 'easypack', primary, 'Low-effort packing');
    }

    if (answers.gift_price_preference === 'premium_gift' || answers.gift_feeling === 'premium_special') {
      addAddOn(addOns, 'gift_box', primary, 'Gift-ready setup');
    }

    if (material.includes('safe_unknown') && primary.containsFeatherDown) {
      return uniqueAddOns(addOns.filter((addOn) => addOn.type !== 'gift')).slice(0, 2);
    }

    return uniqueAddOns(addOns).slice(0, 2);
  }

  function addAddOn(list, addOnId, primary, reasonLabel) {
    const addOn = ACCESSORY_RECORDS.find((record) => record.id === addOnId);
    if (!addOn) return;
    if (!addOn.families.includes(effectiveFamily(primary))) return;

    if (!addOn.available && addOn.id !== 'large_standard_case') return;

    list.push(Object.assign({}, addOn, {
      reasonLabel,
      compatibility: getAddOnCompatibility(addOn, primary),
      availableVariant: addOn.availableVariant || null
    }));
  }

  function getAddOnCompatibility(addOn, primary) {
    if (addOn.type === 'easypack') return 'Only shown for Snoooze pillows that do not already include a Velcro bag.';
    if (addOn.type === 'large_case') return 'Large pillows use standard UK pillowcases and do not include one in the pillow box.';
    if (addOn.type === 'silk_case') return `Compatible with ${familyLabel(effectiveFamily(primary))} pillows.`;
    return `Compatible with ${familyLabel(effectiveFamily(primary))} pillows.`;
  }

  function getBaseProductId(primary) {
    return primary.baseProduct || primary.id;
  }

  function effectiveFamily(product) {
    if (product.family === 'bundle_offer') return 'full_portable';
    return product.family;
  }

  function renderResult(state, result) {
    const path = getPathProperties(state.answers).path;
    const resultLabels = getResultLabels(path, result.tradeoff);
    const eyebrow = resultLabels.eyebrow;
    const heading = resultLabels.heading;
    state.form.hidden = true;
    if (state.panel) state.panel.hidden = true;
    state.resultPanel.hidden = false;
    state.resultContent.innerHTML = `
      <div class="pillow-quiz-result__header">
        <p class="pillow-advisor__eyebrow">${escapeHTML(eyebrow)}</p>
        <h3>${heading}: ${escapeHTML(productTitle(result.primary))}</h3>
      </div>
      <div class="pillow-quiz-result__layout">
        ${renderRecommendationCard(result.primary, state, result, true)}
        ${result.alternative ? renderRecommendationCard(result.alternative, state, result, false) : ''}
      </div>
      ${renderAddOns(result.addOns)}
      ${renderEmailForm(state)}
      <div class="pillow-quiz-result__footer">
        <button class="pillow-quiz__button pillow-quiz__button--secondary" type="button" data-retake-quiz>Retake quiz</button>
      </div>
    `;

    state.resultPanel.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
  }

  function getResultLabels(path, tradeoff) {
    const map = {
      flight: { eyebrow: 'Flight recommendation', heading: 'Your best flight match' },
      hotel: { eyebrow: 'Hotel recommendation', heading: 'Your best hotel match' },
      flight_hotel: { eyebrow: 'Flight + hotel recommendation', heading: 'Your best flight + hotel match' },
      gift: { eyebrow: 'Gift recommendation', heading: 'Your best gift match' },
      unsure: { eyebrow: 'Safest match', heading: 'Your safest Snoooze match' }
    };
    return map[path] || { eyebrow: (tradeoff && tradeoff.label) || 'Your best match', heading: 'Your best match' };
  }

  function renderRecommendationCard(product, state, result, isPrimary) {
    const path = getPathProperties(state.answers).path;
    const giftPath = path === 'gift';
    const flightPath = path === 'flight' || path === 'flight_hotel';
    const title = productTitle(product);
    const label = isPrimary
      ? (result.alternative ? `Option 1 - ${giftPath ? 'Best gift match' : (flightPath ? 'Best flight match' : 'Best match')}` : (giftPath ? 'Best gift match' : (flightPath ? 'Best flight match' : 'Best match')))
      : `Option 2 - ${product.alternativeLabel || 'Useful alternative'}`;
    const why = isPrimary ? buildWhyCopy(product, state.answers, result.tradeoff) : (product.tradeoffCopy || 'This is useful if that trade-off matters more to you.');
    const ctaText = isPrimary ? (giftPath ? 'Choose this gift' : (flightPath ? 'Shop my flight sleep setup' : (state.config.primaryCtaText || 'Shop my travel sleep setup'))) : 'View this option';
    const hasVariant = product.availableVariant && product.availableVariant.id;
    const compareHref = state.config.compareCtaUrl || (state.config.comparisonSectionId ? `#${state.config.comparisonSectionId}` : '/collections/sleep');
    return `
      <article class="pillow-quiz-result__card ${isPrimary ? 'pillow-quiz-result__card--primary' : ''}">
        <div class="pillow-quiz-result__image-wrap">
          ${product.image ? `<img src="${escapeHTML(product.image)}" alt="${escapeHTML(title)}" loading="lazy">` : ''}
        </div>
        <div class="pillow-quiz-result__body">
          <p class="pillow-quiz-result__label">${escapeHTML(label)}</p>
          <h4>${escapeHTML(title)}</h4>
          <p class="pillow-quiz-result__price">${formatMoney(product.price, product.fallbackPrice)}</p>

          <div class="pillow-quiz-result__copy">
            <p><strong>${isPrimary ? ((giftPath || flightPath) ? 'Why this fits:' : 'Why this fits you:') : 'Why you may prefer it:'}</strong> ${escapeHTML(why)}</p>
            <p><strong>Best if:</strong> ${escapeHTML(product.bestIf)}</p>
            <p><strong>Not ideal if:</strong> ${escapeHTML(product.notIdealIf)}</p>
            ${isPrimary ? `<p><strong>${flightPath ? 'How to use it on the flight:' : 'How to use it:'}</strong> ${escapeHTML(buildSetupCopy(product, state.answers, result.tradeoff))}</p>` : `<p><strong>Trade-off:</strong> ${escapeHTML(product.tradeoffCopy || product.notIdealIf)}</p>`}
          </div>

          <div class="pillow-quiz-result__meta">
            <span>${escapeHTML(product.size || '')}</span>
            <span>${escapeHTML(product.feel || product.explainAs || '')}</span>
          </div>

          <div class="pillow-quiz-result__actions">
            ${isPrimary && hasVariant ? `<button class="pillow-quiz__button pillow-quiz__button--primary" type="button" data-add-recommendation data-variant-id="${product.availableVariant.id}" data-product-handle="${escapeHTML(product.handle)}">${escapeHTML(ctaText)}</button>` : `<a class="pillow-quiz__button pillow-quiz__button--primary" href="${escapeHTML(product.url || `/products/${product.handle}`)}" data-product-click data-click-type="${isPrimary ? 'primary' : 'alternative'}" data-product-handle="${escapeHTML(product.handle)}">${escapeHTML(ctaText)}</a>`}
            ${isPrimary ? `<a class="pillow-quiz__button pillow-quiz__button--secondary" href="${escapeHTML(product.url || `/products/${product.handle}`)}" data-product-click data-click-type="primary_details" data-product-handle="${escapeHTML(product.handle)}">View details</a>` : ''}
            ${isPrimary ? `<a class="pillow-quiz__button pillow-quiz__button--secondary" href="${escapeHTML(compareHref)}" data-compare-link>${escapeHTML(state.config.compareCtaText || 'Compare all sizes')}</a>` : ''}
          </div>
        </div>
      </article>
    `;
  }

  function renderAddOns(addOns) {
    if (!addOns.length) return '';
    return `
      <div class="pillow-quiz-addons">
        <h4>Worth adding</h4>
        <div class="pillow-quiz-addons__grid">
          ${addOns.map(renderAddOnCard).join('')}
        </div>
      </div>
    `;
  }

  function renderAddOnCard(addOn) {
    const title = addOn.title || addOn.label;
    const hasVariant = addOn.availableVariant && addOn.availableVariant.id;
    return `
      <article class="pillow-quiz-addon">
        <div>
          <p class="pillow-quiz-addon__label">${escapeHTML(addOn.reasonLabel || 'Add-on')}</p>
          <h5>${escapeHTML(title)}</h5>
          <p>${escapeHTML(addOn.reason)}</p>
          <p class="pillow-quiz-addon__compatibility">${escapeHTML(addOn.compatibility)}</p>
          ${addOn.available ? `<p class="pillow-quiz-addon__price">${formatMoney(addOn.price, null)}</p>` : ''}
        </div>
        ${hasVariant ? `<button class="pillow-quiz__button pillow-quiz__button--secondary" type="button" data-add-addon data-variant-id="${addOn.availableVariant.id}" data-product-handle="${escapeHTML(addOn.handle)}" data-addon-reason="${escapeHTML(addOn.reasonLabel || '')}">Add</button>` : ''}
      </article>
    `;
  }

  function renderEmailForm(state) {
    const path = getPathProperties(state.answers).path;
    const label = path === 'gift'
      ? 'Email me this gift result'
      : (path === 'flight' ? 'Email me my flight result' : (state.config.emailCtaText || 'Email me my result'));
    return `
      <form class="pillow-quiz-email" data-result-email-form>
        <label for="PillowQuizEmail-${escapeHTML(state.config.sectionId || 'default')}">${escapeHTML(label)}</label>
        <div class="pillow-quiz-email__row">
          <input id="PillowQuizEmail-${escapeHTML(state.config.sectionId || 'default')}" type="email" name="email" placeholder="Email address" autocomplete="email" required>
          <button class="pillow-quiz__button pillow-quiz__button--secondary" type="submit">Send</button>
        </div>
        <p class="pillow-quiz-email__status" data-email-status hidden></p>
      </form>
    `;
  }

  function buildWhyCopy(product, answers, tradeoff) {
    if (isGiftPath(answers)) return buildGiftWhyCopy(product, answers);
    if (isFlightPath(answers)) return buildFlightWhyCopy(product, answers, tradeoff);

    const pieces = [
      answerLabel('personal_travel_style', answers.personal_travel_style),
      answerLabel('personal_luggage', answers.personal_luggage),
      firstAnswerLabel('personal_sleep_away_problem', answers.personal_sleep_away_problem),
      answerLabel('personal_pillow_feel', answers.personal_pillow_feel),
      firstAnswerLabel('personal_material_practical_needs', (answers.personal_material_practical_needs || []).filter((item) => item !== 'no_preference'))
    ].filter(Boolean);
    let copy = `You told us ${humanList(pieces.map(cleanAnswerForSentence))}. This points to ${productTitle(product)} because ${getPersonalProductReason(product)}`;

    if (tradeoff.state === 'compact_compromise') {
      copy += ' You want more comfort or support, but your luggage limit points to a compact pillow. This is the best small option.';
    }
    if (tradeoff.state === 'skin_hair_full_support') {
      copy += ' Skin and hair matter, but the pillow size/support still comes first; the smoother surface is best handled with a silk pillowcase.';
    }
    if (tradeoff.state === 'large_comfort_first') {
      copy += ' This is comfort-first travel, not a backpack option.';
    }
    return copy;
  }

  function buildFlightWhyCopy(product, answers, tradeoff) {
    const pieces = [
      answerLabel('flight_use_scope', answers.flight_use_scope),
      answerLabel('flight_length', answers.flight_length),
      answerLabel('flight_onboard_carry', answers.flight_onboard_carry),
      answerLabel('flight_seat_reality', answers.flight_seat_reality),
      firstAnswerLabel('flight_main_needs', answers.flight_main_needs)
    ].filter(Boolean);
    let copy = `You told us ${humanList(pieces.map(cleanAnswerForSentence))}. This points to ${productTitle(product)} because ${getFlightProductReason(product)}`;

    if (tradeoff.state === 'compact_flight_match') {
      copy += ' You want better flight sleep, but your pillow needs to stay small enough to keep with you on board. This is the best compact match.';
    }
    if (tradeoff.state === 'middle_aisle_reality') {
      copy += ' We are keeping the recommendation honest for aisle or middle seats: useful support, without pretending it turns the seat into a bed.';
    }
    if (tradeoff.state === 'flight_hotel_case') {
      copy += ' Because you may use it on the journey and in bed, a spare pillowcase can keep the hotel setup cleaner.';
    }
    if (tradeoff.state === 'skin_hair_flight_support') {
      copy += ' Skin and hair matter, but the pillow size still needs to fit the flight; the smoother surface is best handled with a silk pillowcase.';
    }
    return copy;
  }

  function getFlightProductReason(product) {
    const reasons = {
      mini_snoooze: 'it gives you the easiest compact flight pillow: soft, washable, feather-free, and small enough to actually keep with you on board.',
      all_silk_mini: 'it gives you a compact silk pillow, silk shell, and silk pillowcase for a smoother premium surface while travelling.',
      goose_down_mini: 'it gives the lightest, softest natural-down Mini feel for travellers who like a mouldable, sink-in pillow.',
      supreme_3ch_mini: 'it is the most supportive Mini, with a soft outside and a more structured centre, so it gives more hold without taking full-size space.',
      full_size_snoooze: 'it gives more real-pillow surface than Mini while staying portable, with soft down-alternative comfort and no feather or down.',
      adaptgo: 'it lets you adjust the pillow height with inserts, so it can work flatter for sitting support or fuller when you want more pillow height.',
      goose_flat_full: 'it gives a full-size soft goose-down surface with low height, useful if you hate bulky pillows but want more surface than Mini.',
      goose_down_full: 'it gives a fuller soft-to-medium natural down feel for long flights and hotel use when you have room to keep it with you.',
      supreme_3ch_full: 'it gives the strongest full-size portable support, with soft outer chambers and a more supportive centre for a steadier flight setup.'
    };
    return reasons[product.id] || product.bestIf || 'it best matches your flight answers.';
  }

  function getPersonalProductReason(product) {
    const reasons = {
      mini_snoooze: 'it gives you the easiest compact Snoooze option: soft, washable, feather-free, and useful as your own clean pillow surface away from home.',
      all_silk_mini: 'it gives a compact silk pillow, silk shell, and silk pillowcase for a smoother premium surface without taking much luggage space.',
      goose_down_mini: 'it gives the softest, lightest natural-down Mini feel for travellers who love mouldable, sink-in softness.',
      supreme_3ch_mini: 'it is the most supportive Mini, with a soft outside and a more structured centre for better hold in a compact size.',
      full_size_snoooze: 'it gives more real-pillow surface than Mini while staying portable, with soft down-alternative comfort and no feather/down.',
      adaptgo: 'it lets you adjust the pillow height with inserts, which helps when hotel pillows are different every trip.',
      goose_flat_full: 'it gives a full-size pillow surface with low, soft natural-down height, useful if hotel pillows are often too high or bulky.',
      goose_down_full: 'it gives a fuller soft-to-medium natural down feel for hotels and flights when you have room to pack it.',
      supreme_3ch_full: 'it gives the strongest full-size portable support, with soft outer chambers and a more supportive centre.',
      large_goose_down: 'it is the closest soft home-pillow comfort for long stays, checked luggage, car travel, campers, boats, or extra-bag travel.',
      supreme_3ch_large: 'it gives home-size comfort with more structure, suited to longer stays when support matters more than compact packing.'
    };
    return reasons[product.id] || product.bestIf || 'it best matches your answers.';
  }

  function buildGiftWhyCopy(product, answers) {
    const pieces = [
      answerLabel('user_for_whom', answers.user_for_whom),
      answerLabel('gift_travel_type', answers.gift_travel_type),
      answerLabel('gift_packing_style', answers.gift_packing_style),
      answerLabel('gift_feeling', answers.gift_feeling)
    ].filter(Boolean);
    return `You told us ${humanList(pieces.map(cleanAnswerForSentence))}. This points to ${productTitle(product)} because ${getGiftProductReason(product, answers)}`;
  }

  function getGiftProductReason(product, answers) {
    const reasons = {
      mini_snoooze: 'it is the safest compact travel gift: easy to pack, easy to understand, and useful as a clean soft pillow surface away from home.',
      all_silk_mini: 'it feels more special while staying compact, with silk filling, silk shell, and a silk pillowcase for a smoother premium surface.',
      goose_down_mini: 'it gives a soft natural down feel in a compact size, so it suits someone who likes cosy softness without taking much luggage space.',
      supreme_3ch_mini: 'it is the most supportive compact option, so it suits a gift that should feel more substantial while still staying small.',
      full_size_snoooze: 'it gives more real-pillow surface than Mini while staying portable for hotels, flights, guest rooms, and longer trips.',
      adaptgo: 'its adjustable inserts make it a safer adult or shared gift when pillow preferences may change from trip to trip.',
      goose_flat_full: 'it gives a low, soft, full-size surface for someone who wants natural down comfort without a high pillow feel.',
      goose_down_full: 'it gives a fuller soft natural down feel for hotel stays and premium travel when they have room to pack it.',
      supreme_3ch_full: 'it has soft outer chambers and a more supportive centre, so it suits someone who wants a steadier full-size portable pillow.',
      large_goose_down: 'it is a comfort-first gift for car, camper, boat, checked-luggage, or long-stay travel where pillow space is not the main limit.',
      supreme_3ch_large: 'it is a comfort-first large pillow with more structure, suited to longer stays when they want a home-size pillow feel.'
    };

    if (answers.gift_material_avoidance && answers.gift_material_avoidance.includes('safe_unknown') && product.containsFeatherDown) {
      return 'it matched the comfort answers, but only choose it if you know feather/down is okay for them.';
    }
    return reasons[product.id] || product.bestIf || 'it best matches the gift answers.';
  }

  function hasFlightUse(answers) {
    return isFlightPath(answers) ||
      answers.personal_travel_style === 'flights_sitting' ||
      answers.personal_travel_style === 'travel_and_hotel' ||
      (answers.personal_sleep_away_problem || []).includes('flight_sitting_sleep');
  }

  function getFlightSetupRecommendation(answers) {
    if (!hasFlightUse(answers)) return '';
    if (isFlightPath(answers)) {
      if (answers.flight_seat_reality === 'window') return 'Best setup: choose a window or lie-flat seat when you can, so your head has a stable side surface.';
      if (answers.flight_seat_reality === 'aisle_middle') return 'If your seat changes, keep it flexible: use the pillow by the window when possible, or as a hug, lap, cheek or lower-back pillow in aisle and middle seats.';
      if (answers.flight_seat_reality === 'lie_flat') return 'Use it like a small real pillow with your own clean case.';
      return 'Best setup: choose a window or lie-flat seat when you can. If head support is not realistic, use it as a hug, lap, cheek or lower-back pillow while sitting.';
    }
    return 'Use by a window or lie-flat setup when possible; in middle or aisle, use as hug pillow, cheek support, or lower-back support.';
  }

  function buildSetupCopy(product, answers, tradeoff) {
    if (isGiftPath(answers)) return buildGiftSetupCopy(product, answers);
    if (isFlightPath(answers)) return buildFlightSetupCopy(product, answers);

    if (effectiveFamily(product) === 'large') {
      return 'This is comfort-first travel. It is bulky, has a Velcro travel bag, and needs a standard UK pillowcase. It is not a backpack pillow.';
    }
    if (answers.personal_travel_style === 'flights_sitting' || (answers.personal_sleep_away_problem || []).includes('flight_sitting_sleep')) {
      return 'For long flights, this works best by the window or lie-flat setup, where your head has a stable surface. In a middle or aisle seat, use it as a hug pillow, cheek support, or lower-back support.';
    }
    if (answers.personal_travel_style === 'car_camper_long') {
      return 'For long sitting, keep it rolled in the bag and place it behind the lower back when that feels useful.';
    }
    if ((answers.personal_sleep_away_problem || []).includes('too_high_bulky_hard')) {
      return 'If the hotel pillow is already high, use Snoooze alone first.';
    }
    if ((answers.personal_sleep_away_problem || []).includes('too_low_flat_collapse')) {
      return 'Try it alone first. If the hotel pillow is too low, use the hotel pillow underneath as a base.';
    }
    if (tradeoff.state === 'compact_compromise') {
      return 'Use the compact pillow by itself first. If sleep matters more than space, the full-size alternative will feel closer to a real pillow.';
    }
    return product.setup || 'Try it alone first. If the hotel pillow is too low, use the hotel pillow underneath as a base.';
  }

  function buildFlightSetupCopy(product, answers) {
    const parts = [];

    if (answers.flight_seat_reality === 'window') {
      parts.push('Best setup: choose a window or lie-flat seat when you can, so your head has a stable side surface.');
    } else if (answers.flight_seat_reality === 'aisle_middle') {
      parts.push('If your seat changes, use it by the window when possible, or as a hug, lap, cheek or lower-back pillow in aisle and middle seats.');
    } else if (answers.flight_seat_reality === 'lie_flat') {
      parts.push('Use it like a small real pillow with your own clean case.');
    } else {
      parts.push('Best setup: choose a window or lie-flat seat when you can. If head support is not realistic, use it as a hug, lap, cheek or lower-back pillow while sitting.');
    }

    if (answers.flight_onboard_carry === 'cabin_take_out') {
      parts.push('Take it out before boarding if it is packed in your cabin suitcase.');
    }

    if (['flight_plus_hotel', 'mostly_flight_hotel_bonus'].includes(answers.flight_use_scope)) {
      parts.push('If you also use it in the hotel, switch to a clean pillowcase before bed.');
    }

    if (answers.flight_use_scope === 'long_sitting') {
      parts.push('For long sitting, keep it rolled in the bag and place it behind the lower back when that feels useful.');
    }

    return parts.join(' ');
  }

  function buildGiftSetupCopy(product, answers) {
    if (effectiveFamily(product) === 'large') {
      return 'This is comfort-first travel. It is bulky, has a Velcro travel bag, and needs a standard UK pillowcase. Large pillows do not include a pillowcase.';
    }
    if (answers.gift_travel_type === 'flights_sitting') {
      return 'For long travel days, they can use it as a soft pillow surface, hug pillow, cheek support, or lower-back support depending on the seat. For long sitting, it can also stay rolled in the bag behind the back.';
    }
    if (answers.gift_travel_type === 'travel_and_hotel') {
      return 'They can use it during the journey, then put on a clean case for bed. In a hotel, they can try Snoooze alone first and use the hotel pillow underneath only if they want more height.';
    }
    if (answers.gift_travel_type === 'hotels_work') {
      return 'In hotels, Airbnb stays, or guest rooms, they can use it alone first. If the bed pillow is too low, they can use the hotel pillow underneath as a base.';
    }
    if (answers.gift_travel_type === 'car_camper_long') {
      return 'They can use it as their main comfort pillow for car trips, camper setups, boats, guest stays, and longer base stays where packing space is less tight.';
    }
    return 'They can use it as a clean soft pillow surface on flights, hotels, Airbnb stays, guest rooms, and weekends away.';
  }

  function onResultClick(state, event) {
    const retake = event.target.closest('[data-retake-quiz]');
    if (retake) {
      state.answers = {};
      state.currentStep = 0;
      state.result = null;
      state.started = false;
      state.giftPathStarted = false;
      state.flightPathStarted = false;
      state.pathStarted = '';
      state.abandonTracked = false;
      state.lastInteraction = null;
      clearTimeout(state.firstIntentAdvanceTimer);
      state.form.hidden = false;
      if (state.panel) state.panel.hidden = false;
      state.resultPanel.hidden = true;
      renderStep(state);
      return;
    }

    const compare = event.target.closest('[data-compare-link]');
    if (compare) {
      const href = compare.getAttribute('href') || '';
      if (href.startsWith('#')) {
        const target = document.querySelector(href);
        if (target) {
          event.preventDefault();
          target.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
        }
      }
      return;
    }

    const productLink = event.target.closest('[data-product-click]');
    if (productLink && state.result) {
      track(state, 'Snoooze Quiz Product Clicked', Object.assign(getResultProperties(state, state.result), {
        product_handle: productLink.dataset.productHandle,
        click_type: productLink.dataset.clickType || 'primary',
        add_on_reason: ''
      }));
      return;
    }

    const addButton = event.target.closest('[data-add-addon]');
    if (addButton && state.result) {
      addProductToCart(state, addButton, 'addon');
      return;
    }

    const recommendationButton = event.target.closest('[data-add-recommendation]');
    if (recommendationButton && state.result) {
      addProductToCart(state, recommendationButton, 'primary');
    }
  }

  async function addProductToCart(state, button, clickType) {
    const variantId = button.dataset.variantId;
    if (!variantId) return;
    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding...';

    track(state, 'Snoooze Quiz Add To Cart Clicked', Object.assign(getResultProperties(state, state.result), {
      product_handles: [button.dataset.productHandle],
      primary_product_handle: state.result.primary.handle,
      alternative_product_handle: state.result.alternative ? state.result.alternative.handle : '',
      addon_handles: clickType === 'addon' ? [button.dataset.productHandle] : [],
      total_value: '',
      click_type: clickType,
      add_on_reason: button.dataset.addonReason || ''
    }));

    try {
      const miniCart = document.querySelector('mini-cart');
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      if (miniCart && typeof miniCart.getSectionsToRender === 'function') {
        formData.append('sections', miniCart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
      }

      const config = typeof fetchConfig === 'function'
        ? fetchConfig('javascript')
        : { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } };
      config.headers = config.headers || {};
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      const response = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add', config);
      if (!response.ok) throw new Error('Cart add failed');
      const parsedState = await response.json();
      if (parsedState.status) throw new Error(parsedState.description || 'Cart add failed');
      if (miniCart && parsedState.sections && typeof miniCart.renderContents === 'function') {
        miniCart.renderContents(parsedState);
      } else {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }
      button.textContent = 'Added';
    } catch (error) {
      button.textContent = 'View';
      const handle = button.dataset.productHandle;
      if (handle) window.location.href = `/products/${handle}`;
    } finally {
      setTimeout(() => {
        button.disabled = false;
        if (button.textContent === 'Added') button.textContent = originalText;
      }, 2200);
    }
  }

  function onEmailSubmit(state, event) {
    const form = event.target.closest('[data-result-email-form]');
    if (!form || !state.result) return;
    event.preventDefault();
    const email = new FormData(form).get('email');
    const status = form.querySelector('[data-email-status]');
    const properties = getResultProperties(state, state.result);
    const segmentTags = getSegmentTags(state.answers, state.result);

    identifyKlaviyo(email, Object.assign({}, properties, getProfileProperties(state)));

    track(state, 'Snoooze Quiz Email Submitted', Object.assign({}, properties, {
      result_id: state.result.id,
      primary_product_handle: state.result.primary.handle,
      segment_tags: segmentTags
    }));

    if (status) {
      status.hidden = false;
      status.textContent = 'Result saved for email follow-up.';
    }
  }

  function getProfileProperties(state) {
    const answers = state.answers;
    const result = state.result;
    const giftPath = isGiftPath(answers);
    const flightPath = isFlightPath(answers);

    const base = {
      snoooze_quiz_path: getPathProperties(answers).path,
      snoooze_first_intent: answers.first_intent || '',
      snoooze_quiz_result_id: result.id,
      snoooze_primary_product_handle: result.primary.handle,
      snoooze_alternative_product_handle: result.alternative ? result.alternative.handle : '',
      snoooze_pillow_family: effectiveFamily(result.primary),
      snoooze_last_quiz_date: new Date().toISOString()
    };

    if (giftPath) {
      return Object.assign(base, {
        snoooze_gift_recipient_type: answers.user_for_whom || '',
        snoooze_gift_travel_type: answers.gift_travel_type || '',
        snoooze_gift_packing_style: answers.gift_packing_style || '',
        snoooze_gift_feeling: answers.gift_feeling || '',
        snoooze_gift_price_preference: answers.gift_price_preference || ''
      });
    }

    if (flightPath) {
      return Object.assign(base, {
        snoooze_flight_use_scope: answers.flight_use_scope || '',
        snoooze_flight_length: answers.flight_length || '',
        snoooze_flight_onboard_carry: answers.flight_onboard_carry || '',
        snoooze_flight_seat_reality: answers.flight_seat_reality || '',
        snoooze_flight_main_needs: (answers.flight_main_needs || []).join(',')
      });
    }

    return Object.assign(base, {
      snoooze_personal_travel_style: answers.personal_travel_style || '',
      snoooze_personal_luggage: answers.personal_luggage || '',
      snoooze_personal_sleep_away_problem: (answers.personal_sleep_away_problem || []).join(','),
      snoooze_personal_pillow_feel: answers.personal_pillow_feel || '',
      snoooze_personal_material_practical_needs: (answers.personal_material_practical_needs || []).join(','),
      snoooze_personal_result_preference: answers.personal_result_preference || ''
    });
  }

  function trackStepCompleted(state, question) {
    const value = state.answers[question.id];
    const answerId = Array.isArray(value) ? value.join(',') : value;
    const answerLabelText = Array.isArray(value)
      ? value.map((item) => answerLabel(question.id, item)).join(', ')
      : answerLabel(question.id, value);
    const activeQuestions = getActiveQuestions(state.answers);

    track(state, 'Snoooze Quiz Step Completed', Object.assign(getTrafficProperties(state), getPathProperties(state.answers), {
      step_id: question.id,
      question_id: question.id,
      answer_id: answerId,
      answer_label: answerLabelText,
      step_number: state.currentStep + 1,
      total_steps: activeQuestions.length
    }));
  }

  function trackAnswerSelected(state, question, clickedAnswerId) {
    const value = state.answers[question.id];
    const answerId = Array.isArray(value) ? value.join(',') : value;
    const answerLabelText = Array.isArray(value)
      ? value.map((item) => answerLabel(question.id, item)).join(', ')
      : answerLabel(question.id, value);
    const activeQuestions = getActiveQuestions(state.answers);

    state.lastInteraction = {
      step_id: question.id,
      question_id: question.id,
      answer_id: answerId,
      answer_label: answerLabelText,
      clicked_answer_id: clickedAnswerId,
      clicked_answer_label: answerLabel(question.id, clickedAnswerId),
      step_number: state.currentStep + 1,
      total_steps: activeQuestions.length
    };

    track(state, 'Snoooze Quiz Answer Selected', Object.assign(getTrafficProperties(state), getPathProperties(state.answers), state.lastInteraction));
  }

  function trackAbandonment(state) {
    if (!state.started || state.result || state.abandonTracked) return;
    state.abandonTracked = true;

    const activeQuestions = getActiveQuestions(state.answers);
    const currentQuestion = activeQuestions[state.currentStep] || activeQuestions[activeQuestions.length - 1];
    const lastInteraction = state.lastInteraction || {};

    track(state, 'Snoooze Quiz Abandoned', Object.assign(getTrafficProperties(state), getPathProperties(state.answers), {
      step_id: currentQuestion ? currentQuestion.id : '',
      question_id: currentQuestion ? currentQuestion.id : '',
      step_number: state.currentStep + 1,
      total_steps: activeQuestions.length,
      answered_questions: Object.keys(state.answers).join(','),
      last_answer_id: lastInteraction.answer_id || '',
      last_answer_label: lastInteraction.answer_label || ''
    }));
  }

  function track(state, eventName, properties) {
    const payload = Object.assign({ quiz_version: state.config.quizVersion || 'guided-2026-05-05' }, properties || {});
    const klaviyoQueue = getKlaviyoQueue();
    if (klaviyoQueue) klaviyoQueue.push(['track', eventName, payload]);
    window.dispatchEvent(new CustomEvent('snoooze:quiz_event', {
      detail: { event: eventName, properties: payload }
    }));
  }

  function loadQuizGaBridge() {
    if (window.SnooozeQuizGaBridgeLoaded) return;
    window.SnooozeQuizGaBridgeLoaded = true;

    const allowedEvents = {
      'Snoooze Quiz Started': 'snoooze_quiz_started',
      'Snoooze Quiz First Screen Viewed': 'snoooze_quiz_first_screen_viewed',
      'Snoooze Quiz First Intent Selected': 'snoooze_quiz_first_intent_selected',
      'Snoooze Quiz Path Started': 'snoooze_quiz_path_started',
      'Snoooze Quiz Step Completed': 'snoooze_quiz_step_completed',
      'Snoooze Quiz Completed': 'snoooze_quiz_completed',
      'Snoooze Quiz Result Viewed': 'snoooze_quiz_result_viewed',
      'Snoooze Quiz Product Clicked': 'snoooze_quiz_product_clicked',
      'Snoooze Quiz Add To Cart Clicked': 'snoooze_quiz_add_to_cart_clicked',
      'Snoooze Quiz Email Submitted': 'snoooze_quiz_email_submitted',
      'Snoooze Quiz Gift Path Started': 'snoooze_quiz_gift_path_started',
      'Snoooze Quiz Flight Path Started': 'snoooze_quiz_flight_path_started',
      'Snoooze Quiz Gift Completed': 'snoooze_quiz_gift_completed',
      'Snoooze Quiz Flight Completed': 'snoooze_quiz_flight_completed'
    };

    window.addEventListener('snoooze:quiz_event', (event) => {
      const detail = event.detail || {};
      const properties = detail.properties || {};
      const gaEventName = allowedEvents[detail.event];
      if (!gaEventName) return;

      const gaParams = cleanGaParams({
        quiz_version: properties.quiz_version || '',
        quiz_path: properties.path || properties.quiz_path || '',
        first_intent: properties.first_intent || '',
        selected_label: properties.selected_label || '',
        path_started: properties.path_started || '',
        source_page_type: properties.source_page_type || '',
        page_url: properties.page_url || '',
        step_id: properties.step_id || '',
        question_id: properties.question_id || '',
        answer_id: properties.answer_id || '',
        answer_label: properties.answer_label || '',
        step_number: properties.step_number || '',
        total_steps: properties.total_steps || '',
        result_id: properties.result_id || '',
        primary_product_handle: properties.primary_product_handle || '',
        primary_product_sku: properties.primary_product_sku || '',
        primary_product_family: properties.family_recommended || properties.primary_product_family || '',
        alternative_product_handle: properties.alternative_product_handle || '',
        click_type: properties.click_type || '',
        recommendation_confidence: properties.recommendation_confidence || '',
        value: getGaValue(properties.primary_product_price),
        currency: getGaCurrency()
      });

      if (typeof window.gtag === 'function') {
        window.gtag('event', gaEventName, gaParams);
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: gaEventName }, gaParams));
    });
  }

  function cleanGaParams(params) {
    Object.keys(params).forEach((key) => {
      if (params[key] === '' || params[key] === undefined || params[key] === null) {
        delete params[key];
      }
    });
    return params;
  }

  function getGaValue(price) {
    const value = Number(price);
    if (!Number.isFinite(value) || value <= 0) return undefined;
    return value > 1000 ? value / 100 : value;
  }

  function getGaCurrency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
  }

  function identifyKlaviyo(email, properties) {
    if (!email) return;
    const klaviyoQueue = getKlaviyoQueue();
    if (klaviyoQueue) klaviyoQueue.push(['identify', Object.assign({ $email: email }, properties)]);
  }

  function getKlaviyoQueue() {
    window._learnq = window._learnq || [];
    return Array.isArray(window._learnq) ? window._learnq : null;
  }

  function getTrafficProperties(state) {
    const params = new URLSearchParams(window.location.search);
    return {
      quiz_version: state.config.quizVersion || 'guided-2026-05-05',
      page_url: window.location.href,
      source_page_type: getSourcePageType(),
      traffic_source: document.referrer || '',
      utm_source: params.get('utm_source') || '',
      utm_medium: params.get('utm_medium') || '',
      utm_campaign: params.get('utm_campaign') || ''
    };
  }

  function getSourcePageType() {
    if (document.body && document.body.classList.contains('template-product')) return 'product';
    if (document.body && document.body.classList.contains('template-collection')) return 'collection';
    if (document.body && document.body.classList.contains('template-index')) return 'homepage';
    return (window.location.pathname === '/' || window.location.pathname === '') ? 'homepage' : 'page';
  }

  function getPathProperties(answers) {
    const firstIntent = answers.first_intent || '';
    let path = 'unsure';
    if (firstIntent === 'flight') path = 'flight';
    else if (firstIntent === 'hotel') path = 'hotel';
    else if (firstIntent === 'flight_hotel') path = 'flight_hotel';
    else if (firstIntent === 'gift') path = 'gift';
    else if (firstIntent === 'self') path = 'self';
    else if (firstIntent === 'unsure') path = 'unsure';
    else if (isGiftPath(answers)) path = 'gift';
    else if (isFlightPath(answers)) path = 'flight';
    else if (answers.personal_travel_style === 'hotels_work') path = 'hotel';
    else if (answers.personal_travel_style === 'travel_and_hotel') path = 'flight_hotel';

    return {
      path,
      quiz_path: path,
      first_intent: firstIntent
    };
  }

  function getResultProperties(state, result) {
    const answers = state.answers;
    const giftPath = isGiftPath(answers);
    const flightPath = isFlightPath(answers);
    const material = giftPath
      ? (answers.gift_material_avoidance || [])
      : (flightPath ? (answers.flight_main_needs || []) : (answers.personal_material_practical_needs || []));
    const materialQuestionId = giftPath ? 'gift_material_avoidance' : (flightPath ? 'flight_main_needs' : 'personal_material_practical_needs');
    const personalProblems = answers.personal_sleep_away_problem || [];
    const personalMaterial = answers.personal_material_practical_needs || [];
    const flightNeeds = answers.flight_main_needs || [];
    const properties = Object.assign(getTrafficProperties(state), getPathProperties(answers), {
      result_id: result.id,
      result_title: productTitle(result.primary),
      primary_product_id: result.primary.live && result.primary.live.raw ? result.primary.live.raw.id : '',
      primary_product_handle: result.primary.handle,
      primary_product_sku: result.primary.sku,
      primary_product_price: result.primary.price,
      alternative_product_id: result.alternative && result.alternative.live && result.alternative.live.raw ? result.alternative.live.raw.id : '',
      alternative_product_handle: result.alternative ? result.alternative.handle : '',
      alternative_reason: result.alternative ? result.alternative.alternativeLabel : '',
      add_on_handles: result.addOns.map((item) => item.handle).filter(Boolean),
      addon_handles: result.addOns.map((item) => item.handle).filter(Boolean),
      add_on_reasons: result.addOns.map((item) => item.reasonLabel || item.type),
      family_recommended: effectiveFamily(result.primary),
      primary_product_family: effectiveFamily(result.primary),
      personal_travel_style: answers.personal_travel_style || '',
      personal_travel_style_label: answerLabel('personal_travel_style', answers.personal_travel_style),
      personal_luggage: answers.personal_luggage || '',
      personal_luggage_label: answerLabel('personal_luggage', answers.personal_luggage),
      personal_sleep_away_problem: personalProblems.join(','),
      personal_sleep_away_problem_labels: personalProblems.map((item) => answerLabel('personal_sleep_away_problem', item)).join(', '),
      personal_pillow_feel: answers.personal_pillow_feel || '',
      personal_pillow_feel_label: answerLabel('personal_pillow_feel', answers.personal_pillow_feel),
      personal_material_practical_needs: personalMaterial.join(','),
      personal_material_practical_need_labels: personalMaterial.map((item) => answerLabel('personal_material_practical_needs', item)).join(', '),
      personal_result_preference: answers.personal_result_preference || '',
      personal_result_preference_label: answerLabel('personal_result_preference', answers.personal_result_preference),
      flight_use_scope: answers.flight_use_scope || '',
      flight_use_scope_label: answerLabel('flight_use_scope', answers.flight_use_scope),
      flight_length: answers.flight_length || '',
      flight_length_label: answerLabel('flight_length', answers.flight_length),
      flight_onboard_carry: answers.flight_onboard_carry || '',
      flight_onboard_carry_label: answerLabel('flight_onboard_carry', answers.flight_onboard_carry),
      flight_seat_reality: answers.flight_seat_reality || '',
      flight_seat_reality_label: answerLabel('flight_seat_reality', answers.flight_seat_reality),
      flight_main_needs: flightNeeds.join(','),
      flight_main_need_labels: flightNeeds.map((item) => answerLabel('flight_main_needs', item)).join(', '),
      user_for_whom: answers.user_for_whom || '',
      user_for_whom_label: answerLabel('user_for_whom', answers.user_for_whom),
      material_filters: material.join(','),
      material_filter_labels: material.map((item) => answerLabel(materialQuestionId, item)).join(', '),
      skin_hair_interest: giftPath ? answers.gift_feeling === 'skin_hair_hot' : material.includes('skin_hair_hot'),
      hot_sleep: giftPath ? answers.gift_feeling === 'skin_hair_hot' : material.includes('skin_hair_hot'),
      packing_preference: material.includes('low_effort_packing') ? 'low_effort_packing' : '',
      flight_setup_recommendation: getFlightSetupRecommendation(answers),
      recipient_type: giftPath ? answers.user_for_whom || '' : '',
      recipient_type_label: giftPath ? answerLabel('user_for_whom', answers.user_for_whom) : '',
      gift_travel_type: answers.gift_travel_type || '',
      gift_travel_type_label: answerLabel('gift_travel_type', answers.gift_travel_type),
      gift_packing_style: answers.gift_packing_style || '',
      gift_packing_style_label: answerLabel('gift_packing_style', answers.gift_packing_style),
      gift_feeling: answers.gift_feeling || '',
      gift_feeling_label: answerLabel('gift_feeling', answers.gift_feeling),
      gift_material_avoidance: (answers.gift_material_avoidance || []).join(','),
      gift_material_avoidance_labels: (answers.gift_material_avoidance || []).map((item) => answerLabel('gift_material_avoidance', item)).join(', '),
      gift_price_preference: answers.gift_price_preference || '',
      gift_price_preference_label: answerLabel('gift_price_preference', answers.gift_price_preference),
      tradeoff_state: result.tradeoff.state || '',
      recommendation_confidence: result.confidence,
      score_primary: result.scorePrimary,
      score_alternative: result.scoreAlternative
    });

    return properties;
  }

  function getSegmentTags(answers, result) {
    if (isGiftPath(answers)) return getGiftSegmentTags(answers, result);
    if (isFlightPath(answers)) return getFlightSegmentTags(answers, result);

    const tags = ['quiz_personal'];
    const material = answers.personal_material_practical_needs || [];
    const problems = answers.personal_sleep_away_problem || [];
    const primaryFamily = effectiveFamily(result.primary);
    if (primaryFamily === 'mini') tags.push('quiz_compact_traveller');
    if (primaryFamily === 'full_portable') tags.push('quiz_full_size_traveller');
    if (primaryFamily === 'large') tags.push('quiz_large_comfort_first');
    if (answers.personal_travel_style === 'flights_sitting') tags.push('quiz_personal_flights');
    if (answers.personal_travel_style === 'hotels_work') tags.push('quiz_personal_hotels');
    if (answers.personal_travel_style === 'travel_and_hotel') tags.push('quiz_personal_flight_hotel');
    if (answers.personal_travel_style === 'car_camper_long') tags.push('quiz_personal_long_stay');
    if (problems.includes('clean_surface')) tags.push('quiz_hotel_hygiene');
    if (material.includes('skin_hair_hot')) {
      tags.push('quiz_skin_hair');
      tags.push('quiz_hot_sleep');
    }
    if (answers.personal_result_preference === 'best_value_first' || answers.personal_result_preference === 'best_plus_lower') tags.push('quiz_price_sensitive');
    if (answers.personal_pillow_feel === 'adjustable') tags.push('quiz_exact_height');
    if (material.includes('avoid_down')) tags.push('quiz_no_down');
    if (material.includes('avoid_latex')) tags.push('quiz_no_latex');
    if (material.includes('low_effort_packing')) tags.push('quiz_low_effort_packing');
    if (answers.personal_pillow_feel === 'more_supportive' || problems.includes('too_low_flat_collapse')) tags.push('quiz_supportive_need');
    if (answers.personal_pillow_feel === 'low_soft' || problems.includes('too_high_bulky_hard')) tags.push('quiz_low_soft_need');
    if (material.includes('natural_down')) tags.push('quiz_natural_down');
    return tags;
  }

  function getFlightSegmentTags(answers, result) {
    const tags = ['quiz_flight'];
    const needs = answers.flight_main_needs || [];
    const primaryFamily = effectiveFamily(result.primary);

    if (answers.flight_use_scope === 'flight_only') tags.push('quiz_flight_only');
    if (['flight_plus_hotel', 'mostly_flight_hotel_bonus'].includes(answers.flight_use_scope)) tags.push('quiz_flight_plus_hotel');
    if (answers.flight_length === 'six_plus') tags.push('quiz_long_haul');
    if (answers.flight_length === 'overnight') tags.push('quiz_overnight_flight');
    if (answers.flight_seat_reality === 'window') tags.push('quiz_window_seat');
    if (answers.flight_seat_reality === 'aisle_middle') tags.push('quiz_middle_aisle');
    if (primaryFamily === 'mini') tags.push('quiz_compact_flight');
    if (primaryFamily === 'full_portable') tags.push('quiz_full_size_flight');
    if (needs.includes('clean_surface')) tags.push('quiz_flight_clean_surface');
    if (needs.includes('more_support')) tags.push('quiz_flight_support_needed');
    if (needs.includes('skin_hair_hot')) {
      tags.push('quiz_flight_skin_hair');
    }
    if (needs.includes('avoid_down')) tags.push('quiz_no_down');
    if (needs.includes('avoid_latex')) tags.push('quiz_no_latex');
    if (needs.includes('low_effort_packing')) tags.push('quiz_low_effort_packing');
    if (needs.includes('best_value')) tags.push('quiz_price_sensitive');

    return unique(tags);
  }

  function getGiftSegmentTags(answers, result) {
    const tags = ['quiz_gift'];
    const material = answers.gift_material_avoidance || [];
    const primaryFamily = effectiveFamily(result.primary);

    if (answers.user_for_whom === 'gift_young') tags.push('quiz_gift_younger');
    if (answers.user_for_whom === 'gift_adult') tags.push('quiz_gift_adult');
    if (answers.user_for_whom === 'gift_parent') tags.push('quiz_gift_parent');
    if (answers.user_for_whom === 'gift_couple') tags.push('quiz_gift_couple');
    if (answers.user_for_whom === 'gift_unsure' || answers.gift_travel_type === 'safe_travel_gift') tags.push('quiz_gift_safe_choice');
    if (answers.gift_price_preference === 'premium_gift' || answers.gift_feeling === 'premium_special') tags.push('quiz_gift_premium');
    if (answers.gift_price_preference === 'value_gift' || answers.gift_price_preference === 'best_plus_lower') tags.push('quiz_gift_price_sensitive');
    if (answers.gift_feeling === 'skin_hair_hot') tags.push('quiz_gift_skin_hair');
    if (material.includes('avoid_down')) tags.push('quiz_gift_no_down');
    if (material.includes('avoid_latex')) tags.push('quiz_gift_no_latex');
    if (primaryFamily === 'full_portable') tags.push('quiz_gift_full_size');
    if (primaryFamily === 'mini') tags.push('quiz_gift_compact');
    if (primaryFamily === 'large' || answers.gift_travel_type === 'car_camper_long') tags.push('quiz_gift_long_stay');

    return tags;
  }

  function showError(state, message) {
    state.error.hidden = false;
    state.error.textContent = message;
  }

  function findFirstByIds(candidates, ids) {
    return ids.map((id) => candidates.find((record) => record.id === id)).find(Boolean) || null;
  }

  function unique(values) {
    return Array.from(new Set(values));
  }

  function queryInputsByName(form, name, suffix) {
    const escaped = window.CSS && window.CSS.escape ? window.CSS.escape(name) : String(name).replace(/"/g, '\\"');
    return form.querySelectorAll(`input[name="${escaped}"]${suffix || ''}`);
  }

  function uniqueAddOns(addOns) {
    const seen = new Set();
    return addOns.filter((addOn) => {
      if (seen.has(addOn.id)) return false;
      seen.add(addOn.id);
      return true;
    });
  }

  function answerLabel(questionId, answerId) {
    if (!answerId) return '';
    return ANSWER_LABELS[`${questionId}:${answerId}`] || answerId;
  }

  function firstAnswerLabel(questionId, answerIds) {
    const values = Array.isArray(answerIds) ? answerIds : [answerIds];
    const labels = values.filter(Boolean).map((value) => answerLabel(questionId, value));
    return labels[0] || '';
  }

  function cleanAnswerForSentence(label) {
    return label
      .replace(/^Me - /, '')
      .replace(/ - /g, ', ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function humanList(items) {
    const clean = items.filter(Boolean);
    if (!clean.length) return 'your answers';
    if (clean.length === 1) return clean[0];
    if (clean.length === 2) return `${clean[0]} and ${clean[1]}`;
    return `${clean.slice(0, -1).join(', ')}, and ${clean[clean.length - 1]}`;
  }

  function productTitle(product) {
    return product.title || product.explainAs || handleToTitle(product.handle || product.id);
  }

  function familyLabel(family) {
    if (family === 'mini') return 'Mini';
    if (family === 'full_portable') return 'Full-size portable';
    if (family === 'large') return 'Large';
    return 'Snoooze';
  }

  function formatMoney(priceInCents, fallbackPounds) {
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
    const amount = typeof priceInCents === 'number'
      ? priceInCents / 100
      : (typeof fallbackPounds === 'number' ? fallbackPounds : null);
    if (amount === null) return '';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(amount);
    } catch (error) {
      return `${currency} ${amount.toFixed(2)}`;
    }
  }

  function handleToTitle(handle) {
    return String(handle || '')
      .split('-')
      .filter(Boolean)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  function getConfidence(primaryScore, alternativeScore) {
    if (!alternativeScore && alternativeScore !== 0) return 'high';
    const gap = primaryScore - alternativeScore;
    if (gap >= 12) return 'high';
    if (gap >= 5) return 'medium';
    return 'balanced_tradeoff';
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function escapeHTML(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  loadQuizGaBridge();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
